import Br from "react";
import { StyleSheet as le, Document as ce, Page as ue, View as m, Image as ne, Text as a } from "@react-pdf/renderer";
import { pdf as oo } from "@react-pdf/renderer";
function Gr(d) {
  return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
}
var Pe = { exports: {} }, ge = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function Xr() {
  if (Tt) return ge;
  Tt = 1;
  var d = Symbol.for("react.transitional.element"), f = Symbol.for("react.fragment");
  function v(h, y, p) {
    var x = null;
    if (p !== void 0 && (x = "" + p), y.key !== void 0 && (x = "" + y.key), "key" in y) {
      p = {};
      for (var s in y)
        s !== "key" && (p[s] = y[s]);
    } else p = y;
    return y = p.ref, {
      $$typeof: d,
      type: h,
      key: x,
      ref: y !== void 0 ? y : null,
      props: p
    };
  }
  return ge.Fragment = f, ge.jsx = v, ge.jsxs = v, ge;
}
var me = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dt;
function Zr() {
  return Dt || (Dt = 1, process.env.NODE_ENV !== "production" && (function() {
    function d(j) {
      if (j == null) return null;
      if (typeof j == "function")
        return j.$$typeof === I ? null : j.displayName || j.name || null;
      if (typeof j == "string") return j;
      switch (j) {
        case u:
          return "Fragment";
        case S:
          return "Profiler";
        case _:
          return "StrictMode";
        case Q:
          return "Suspense";
        case ee:
          return "SuspenseList";
        case A:
          return "Activity";
      }
      if (typeof j == "object")
        switch (typeof j.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), j.$$typeof) {
          case c:
            return "Portal";
          case C:
            return (j.displayName || "Context") + ".Provider";
          case R:
            return (j._context.displayName || "Context") + ".Consumer";
          case U:
            var k = j.render;
            return j = j.displayName, j || (j = k.displayName || k.name || "", j = j !== "" ? "ForwardRef(" + j + ")" : "ForwardRef"), j;
          case se:
            return k = j.displayName || null, k !== null ? k : d(j.type) || "Memo";
          case oe:
            k = j._payload, j = j._init;
            try {
              return d(j(k));
            } catch {
            }
        }
      return null;
    }
    function f(j) {
      return "" + j;
    }
    function v(j) {
      try {
        f(j);
        var k = !1;
      } catch {
        k = !0;
      }
      if (k) {
        k = console;
        var F = k.error, H = typeof Symbol == "function" && Symbol.toStringTag && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return F.call(
          k,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          H
        ), f(j);
      }
    }
    function h(j) {
      if (j === u) return "<>";
      if (typeof j == "object" && j !== null && j.$$typeof === oe)
        return "<...>";
      try {
        var k = d(j);
        return k ? "<" + k + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function y() {
      var j = B.A;
      return j === null ? null : j.getOwner();
    }
    function p() {
      return Error("react-stack-top-frame");
    }
    function x(j) {
      if (P.call(j, "key")) {
        var k = Object.getOwnPropertyDescriptor(j, "key").get;
        if (k && k.isReactWarning) return !1;
      }
      return j.key !== void 0;
    }
    function s(j, k) {
      function F() {
        ke || (ke = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          k
        ));
      }
      F.isReactWarning = !0, Object.defineProperty(j, "key", {
        get: F,
        configurable: !0
      });
    }
    function l() {
      var j = d(this.type);
      return Ce[j] || (Ce[j] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), j = this.props.ref, j !== void 0 ? j : null;
    }
    function e(j, k, F, H, te, J, _t, St) {
      return F = J.ref, j = {
        $$typeof: i,
        type: j,
        key: k,
        props: J,
        _owner: te
      }, (F !== void 0 ? F : null) !== null ? Object.defineProperty(j, "ref", {
        enumerable: !1,
        get: l
      }) : Object.defineProperty(j, "ref", { enumerable: !1, value: null }), j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(j, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(j, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: _t
      }), Object.defineProperty(j, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: St
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    }
    function t(j, k, F, H, te, J, _t, St) {
      var W = k.children;
      if (W !== void 0)
        if (H)
          if (N(W)) {
            for (H = 0; H < W.length; H++)
              o(W[H]);
            Object.freeze && Object.freeze(W);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else o(W);
      if (P.call(k, "key")) {
        W = d(j);
        var de = Object.keys(k).filter(function(Ur) {
          return Ur !== "key";
        });
        H = 0 < de.length ? "{key: someKey, " + de.join(": ..., ") + ": ...}" : "{key: someKey}", Ot[W + H] || (de = 0 < de.length ? "{" + de.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          H,
          W,
          de,
          W
        ), Ot[W + H] = !0);
      }
      if (W = null, F !== void 0 && (v(F), W = "" + F), x(k) && (v(k.key), W = "" + k.key), "key" in k) {
        F = {};
        for (var jt in k)
          jt !== "key" && (F[jt] = k[jt]);
      } else F = k;
      return W && s(
        F,
        typeof j == "function" ? j.displayName || j.name || "Unknown" : j
      ), e(
        j,
        W,
        J,
        te,
        y(),
        F,
        _t,
        St
      );
    }
    function o(j) {
      typeof j == "object" && j !== null && j.$$typeof === i && j._store && (j._store.validated = 1);
    }
    var n = Br, i = Symbol.for("react.transitional.element"), c = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), _ = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), C = Symbol.for("react.context"), U = Symbol.for("react.forward_ref"), Q = Symbol.for("react.suspense"), ee = Symbol.for("react.suspense_list"), se = Symbol.for("react.memo"), oe = Symbol.for("react.lazy"), A = Symbol.for("react.activity"), I = Symbol.for("react.client.reference"), B = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, P = Object.prototype.hasOwnProperty, N = Array.isArray, q = console.createTask ? console.createTask : function() {
      return null;
    };
    n = {
      react_stack_bottom_frame: function(j) {
        return j();
      }
    };
    var ke, Ce = {}, Rt = n.react_stack_bottom_frame.bind(
      n,
      p
    )(), Et = q(h(p)), Ot = {};
    me.Fragment = u, me.jsx = function(j, k, F, H, te) {
      var J = 1e4 > B.recentlyCreatedOwnerStacks++;
      return t(
        j,
        k,
        F,
        !1,
        H,
        te,
        J ? Error("react-stack-top-frame") : Rt,
        J ? q(h(j)) : Et
      );
    }, me.jsxs = function(j, k, F, H, te) {
      var J = 1e4 > B.recentlyCreatedOwnerStacks++;
      return t(
        j,
        k,
        F,
        !0,
        H,
        te,
        J ? Error("react-stack-top-frame") : Rt,
        J ? q(h(j)) : Et
      );
    };
  })()), me;
}
var At;
function Kr() {
  return At || (At = 1, process.env.NODE_ENV === "production" ? Pe.exports = Xr() : Pe.exports = Zr()), Pe.exports;
}
var r = Kr(), Ie = {}, pe = {}, Be = {}, kt;
function K() {
  if (kt) return Be;
  kt = 1, Object.defineProperty(Be, "__esModule", {
    value: !0
  });
  function d(v, h) {
    if (!(v instanceof h))
      throw new TypeError("Cannot call a class as a function");
  }
  var f = function v(h, y) {
    d(this, v), this.data = h, this.text = y.text || h, this.options = y;
  };
  return Be.default = f, Be;
}
var Ct;
function Yr() {
  if (Ct) return pe;
  Ct = 1, Object.defineProperty(pe, "__esModule", {
    value: !0
  }), pe.CODE39 = void 0;
  var d = /* @__PURE__ */ (function() {
    function u(_, S) {
      for (var R = 0; R < S.length; R++) {
        var C = S[R];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(_, C.key, C);
      }
    }
    return function(_, S, R) {
      return S && u(_.prototype, S), R && u(_, R), _;
    };
  })(), f = K(), v = h(f);
  function h(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function y(u, _) {
    if (!(u instanceof _))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(u, _) {
    if (!u)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return _ && (typeof _ == "object" || typeof _ == "function") ? _ : u;
  }
  function x(u, _) {
    if (typeof _ != "function" && _ !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof _);
    u.prototype = Object.create(_ && _.prototype, { constructor: { value: u, enumerable: !1, writable: !0, configurable: !0 } }), _ && (Object.setPrototypeOf ? Object.setPrototypeOf(u, _) : u.__proto__ = _);
  }
  var s = (function(u) {
    x(_, u);
    function _(S, R) {
      return y(this, _), S = S.toUpperCase(), R.mod43 && (S += n(c(S))), p(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, S, R));
    }
    return d(_, [{
      key: "encode",
      value: function() {
        for (var R = t("*"), C = 0; C < this.data.length; C++)
          R += t(this.data[C]) + "0";
        return R += t("*"), {
          data: R,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
      }
    }]), _;
  })(v.default), l = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"], e = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
  function t(u) {
    return o(i(u));
  }
  function o(u) {
    return e[u].toString(2);
  }
  function n(u) {
    return l[u];
  }
  function i(u) {
    return l.indexOf(u);
  }
  function c(u) {
    for (var _ = 0, S = 0; S < u.length; S++)
      _ += i(u[S]);
    return _ = _ % 43, _;
  }
  return pe.CODE39 = s, pe;
}
var Y = {}, Ne = {}, Me = {}, L = {}, Pt;
function Oe() {
  if (Pt) return L;
  Pt = 1, Object.defineProperty(L, "__esModule", {
    value: !0
  });
  var d;
  function f(l, e, t) {
    return e in l ? Object.defineProperty(l, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : l[e] = t, l;
  }
  var v = L.SET_A = 0, h = L.SET_B = 1, y = L.SET_C = 2;
  L.SHIFT = 98;
  var p = L.START_A = 103, x = L.START_B = 104, s = L.START_C = 105;
  return L.MODULO = 103, L.STOP = 106, L.FNC1 = 207, L.SET_BY_CODE = (d = {}, f(d, p, v), f(d, x, h), f(d, s, y), d), L.SWAP = {
    101: v,
    100: h,
    99: y
  }, L.A_START_CHAR = "Ð", L.B_START_CHAR = "Ñ", L.C_START_CHAR = "Ò", L.A_CHARS = "[\0-_È-Ï]", L.B_CHARS = "[ -È-Ï]", L.C_CHARS = "(Ï*[0-9]{2}Ï*)", L.BARS = [11011001100, 11001101100, 11001100110, 10010011e3, 10010001100, 10001001100, 10011001e3, 10011000100, 10001100100, 11001001e3, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011e3, 11011000110, 11000110110, 10100011e3, 10001011e3, 10001000110, 10110001e3, 10001101e3, 10001100010, 11010001e3, 11000101e3, 11000100010, 10110111e3, 10110001110, 10001101110, 10111011e3, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101e3, 11011100010, 11011101110, 11101011e3, 11101000110, 11100010110, 11101101e3, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 1010011e4, 10100001100, 1001011e4, 10010000110, 10000101100, 10000100110, 1011001e4, 10110000100, 1001101e4, 10011000010, 10000110100, 10000110010, 11000010010, 1100101e4, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111e3, 10100011110, 10001011110, 10111101e3, 10111100010, 11110101e3, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 1101001e4, 11010011100, 1100011101011], L;
}
var It;
function pt() {
  if (It) return Me;
  It = 1, Object.defineProperty(Me, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = K(), v = y(f), h = Oe();
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      p(this, t);
      var i = x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, o.substring(1), n));
      return i.bytes = o.split("").map(function(c) {
        return c.charCodeAt(0);
      }), i;
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
      }
      // The public encoding function
    }, {
      key: "encode",
      value: function() {
        var n = this.bytes, i = n.shift() - 105, c = h.SET_BY_CODE[i];
        if (c === void 0)
          throw new RangeError("The encoding does not start with a start character.");
        this.shouldEncodeAsEan128() === !0 && n.unshift(h.FNC1);
        var u = t.next(n, 1, c);
        return {
          text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
          data: (
            // Add the start bits
            t.getBar(i) + // Add the encoded bits
            u.result + // Add the checksum
            t.getBar((u.checksum + i) % h.MODULO) + // Add the end bits
            t.getBar(h.STOP)
          )
        };
      }
      // GS1-128/EAN-128
    }, {
      key: "shouldEncodeAsEan128",
      value: function() {
        var n = this.options.ean128 || !1;
        return typeof n == "string" && (n = n.toLowerCase() === "true"), n;
      }
      // Get a bar symbol by index
    }], [{
      key: "getBar",
      value: function(n) {
        return h.BARS[n] ? h.BARS[n].toString() : "";
      }
      // Correct an index by a set and shift it from the bytes array
    }, {
      key: "correctIndex",
      value: function(n, i) {
        if (i === h.SET_A) {
          var c = n.shift();
          return c < 32 ? c + 64 : c - 32;
        } else return i === h.SET_B ? n.shift() - 32 : (n.shift() - 48) * 10 + n.shift() - 48;
      }
    }, {
      key: "next",
      value: function(n, i, c) {
        if (!n.length)
          return { result: "", checksum: 0 };
        var u = void 0, _ = void 0;
        if (n[0] >= 200) {
          _ = n.shift() - 105;
          var S = h.SWAP[_];
          S !== void 0 ? u = t.next(n, i + 1, S) : ((c === h.SET_A || c === h.SET_B) && _ === h.SHIFT && (n[0] = c === h.SET_A ? n[0] > 95 ? n[0] - 96 : n[0] : n[0] < 32 ? n[0] + 96 : n[0]), u = t.next(n, i + 1, c));
        } else
          _ = t.correctIndex(n, c), u = t.next(n, i + 1, c);
        var R = t.getBar(_), C = _ * i;
        return {
          result: R + u.result,
          checksum: C + u.checksum
        };
      }
    }]), t;
  })(v.default);
  return Me.default = l, Me;
}
var Fe = {}, Bt;
function Jr() {
  if (Bt) return Fe;
  Bt = 1, Object.defineProperty(Fe, "__esModule", {
    value: !0
  });
  var d = Oe(), f = function(s) {
    return s.match(new RegExp("^" + d.A_CHARS + "*"))[0].length;
  }, v = function(s) {
    return s.match(new RegExp("^" + d.B_CHARS + "*"))[0].length;
  }, h = function(s) {
    return s.match(new RegExp("^" + d.C_CHARS + "*"))[0];
  };
  function y(x, s) {
    var l = s ? d.A_CHARS : d.B_CHARS, e = x.match(new RegExp("^(" + l + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
    if (e)
      return e[1] + "Ì" + p(x.substring(e[1].length));
    var t = x.match(new RegExp("^" + l + "+"))[0];
    return t.length === x.length ? x : t + String.fromCharCode(s ? 205 : 206) + y(x.substring(t.length), !s);
  }
  function p(x) {
    var s = h(x), l = s.length;
    if (l === x.length)
      return x;
    x = x.substring(l);
    var e = f(x) >= v(x);
    return s + String.fromCharCode(e ? 206 : 205) + y(x, e);
  }
  return Fe.default = function(x) {
    var s = void 0, l = h(x).length;
    if (l >= 2)
      s = d.C_START_CHAR + p(x);
    else {
      var e = f(x) > v(x);
      s = (e ? d.A_START_CHAR : d.B_START_CHAR) + y(x, e);
    }
    return s.replace(
      /[\xCD\xCE]([^])[\xCD\xCE]/,
      // Any sequence between 205 and 206 characters
      function(t, o) {
        return "Ë" + o;
      }
    );
  }, Fe;
}
var Nt;
function Qr() {
  if (Nt) return Ne;
  Nt = 1, Object.defineProperty(Ne, "__esModule", {
    value: !0
  });
  var d = pt(), f = y(d), v = Jr(), h = y(v);
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      if (p(this, t), /^[\x00-\x7F\xC8-\xD3]+$/.test(o))
        var i = x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, (0, h.default)(o), n));
      else
        var i = x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, o, n));
      return x(i);
    }
    return t;
  })(f.default);
  return Ne.default = l, Ne;
}
var Le = {}, Mt;
function $r() {
  if (Mt) return Le;
  Mt = 1, Object.defineProperty(Le, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = pt(), v = y(f), h = Oe();
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      return p(this, t), x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, h.A_START_CHAR + o, n));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + h.A_CHARS + "+$").test(this.data);
      }
    }]), t;
  })(v.default);
  return Le.default = l, Le;
}
var ze = {}, Ft;
function en() {
  if (Ft) return ze;
  Ft = 1, Object.defineProperty(ze, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = pt(), v = y(f), h = Oe();
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      return p(this, t), x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, h.B_START_CHAR + o, n));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + h.B_CHARS + "+$").test(this.data);
      }
    }]), t;
  })(v.default);
  return ze.default = l, ze;
}
var qe = {}, Lt;
function tn() {
  if (Lt) return qe;
  Lt = 1, Object.defineProperty(qe, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = pt(), v = y(f), h = Oe();
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      return p(this, t), x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, h.C_START_CHAR + o, n));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return new RegExp("^" + h.C_CHARS + "+$").test(this.data);
      }
    }]), t;
  })(v.default);
  return qe.default = l, qe;
}
var zt;
function rn() {
  if (zt) return Y;
  zt = 1, Object.defineProperty(Y, "__esModule", {
    value: !0
  }), Y.CODE128C = Y.CODE128B = Y.CODE128A = Y.CODE128 = void 0;
  var d = Qr(), f = l(d), v = $r(), h = l(v), y = en(), p = l(y), x = tn(), s = l(x);
  function l(e) {
    return e && e.__esModule ? e : { default: e };
  }
  return Y.CODE128 = f.default, Y.CODE128A = h.default, Y.CODE128B = p.default, Y.CODE128C = s.default, Y;
}
var V = {}, He = {}, $ = {}, qt;
function Te() {
  return qt || (qt = 1, Object.defineProperty($, "__esModule", {
    value: !0
  }), $.SIDE_BIN = "101", $.MIDDLE_BIN = "01010", $.BINARIES = {
    L: [
      // The L (left) type of encoding
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    G: [
      // The G type of encoding
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ],
    R: [
      // The R (right) type of encoding
      "1110010",
      "1100110",
      "1101100",
      "1000010",
      "1011100",
      "1001110",
      "1010000",
      "1000100",
      "1001000",
      "1110100"
    ],
    O: [
      // The O (odd) encoding for UPC-E
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    E: [
      // The E (even) encoding for UPC-E
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ]
  }, $.EAN2_STRUCTURE = ["LL", "LG", "GL", "GG"], $.EAN5_STRUCTURE = ["GGLLL", "GLGLL", "GLLGL", "GLLLG", "LGGLL", "LLGGL", "LLLGG", "LGLGL", "LGLLG", "LLGLG"], $.EAN13_STRUCTURE = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"]), $;
}
var We = {}, Ve = {}, Ht;
function De() {
  if (Ht) return Ve;
  Ht = 1, Object.defineProperty(Ve, "__esModule", {
    value: !0
  });
  var d = Te(), f = function(h, y, p) {
    var x = h.split("").map(function(l, e) {
      return d.BINARIES[y[e]];
    }).map(function(l, e) {
      return l ? l[h[e]] : "";
    });
    if (p) {
      var s = h.length - 1;
      x = x.map(function(l, e) {
        return e < s ? l + p : l;
      });
    }
    return x.join("");
  };
  return Ve.default = f, Ve;
}
var Wt;
function Nr() {
  if (Wt) return We;
  Wt = 1, Object.defineProperty(We, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function o(n, i) {
      for (var c = 0; c < i.length; c++) {
        var u = i[c];
        u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(n, u.key, u);
      }
    }
    return function(n, i, c) {
      return i && o(n.prototype, i), c && o(n, c), n;
    };
  })(), f = Te(), v = De(), h = x(v), y = K(), p = x(y);
  function x(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function s(o, n) {
    if (!(o instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(o, n) {
    if (!o)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : o;
  }
  function e(o, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    o.prototype = Object.create(n && n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(o, n) : o.__proto__ = n);
  }
  var t = (function(o) {
    e(n, o);
    function n(i, c) {
      s(this, n);
      var u = l(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, i, c));
      return u.fontSize = !c.flat && c.fontSize > c.width * 10 ? c.width * 10 : c.fontSize, u.guardHeight = c.height + u.fontSize / 2 + c.textMargin, u;
    }
    return d(n, [{
      key: "encode",
      value: function() {
        return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
      }
    }, {
      key: "leftText",
      value: function(c, u) {
        return this.text.substr(c, u);
      }
    }, {
      key: "leftEncode",
      value: function(c, u) {
        return (0, h.default)(c, u);
      }
    }, {
      key: "rightText",
      value: function(c, u) {
        return this.text.substr(c, u);
      }
    }, {
      key: "rightEncode",
      value: function(c, u) {
        return (0, h.default)(c, u);
      }
    }, {
      key: "encodeGuarded",
      value: function() {
        var c = { fontSize: this.fontSize }, u = { height: this.guardHeight };
        return [{ data: f.SIDE_BIN, options: u }, { data: this.leftEncode(), text: this.leftText(), options: c }, { data: f.MIDDLE_BIN, options: u }, { data: this.rightEncode(), text: this.rightText(), options: c }, { data: f.SIDE_BIN, options: u }];
      }
    }, {
      key: "encodeFlat",
      value: function() {
        var c = [f.SIDE_BIN, this.leftEncode(), f.MIDDLE_BIN, this.rightEncode(), f.SIDE_BIN];
        return {
          data: c.join(""),
          text: this.text
        };
      }
    }]), n;
  })(p.default);
  return We.default = t, We;
}
var Vt;
function nn() {
  if (Vt) return He;
  Vt = 1, Object.defineProperty(He, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function o(n, i) {
      for (var c = 0; c < i.length; c++) {
        var u = i[c];
        u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(n, u.key, u);
      }
    }
    return function(n, i, c) {
      return i && o(n.prototype, i), c && o(n, c), n;
    };
  })(), f = function o(n, i, c) {
    n === null && (n = Function.prototype);
    var u = Object.getOwnPropertyDescriptor(n, i);
    if (u === void 0) {
      var _ = Object.getPrototypeOf(n);
      return _ === null ? void 0 : o(_, i, c);
    } else {
      if ("value" in u)
        return u.value;
      var S = u.get;
      return S === void 0 ? void 0 : S.call(c);
    }
  }, v = Te(), h = Nr(), y = p(h);
  function p(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function x(o, n) {
    if (!(o instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(o, n) {
    if (!o)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : o;
  }
  function l(o, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    o.prototype = Object.create(n && n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(o, n) : o.__proto__ = n);
  }
  var e = function(n) {
    var i = n.substr(0, 12).split("").map(function(c) {
      return +c;
    }).reduce(function(c, u, _) {
      return _ % 2 ? c + u * 3 : c + u;
    }, 0);
    return (10 - i % 10) % 10;
  }, t = (function(o) {
    l(n, o);
    function n(i, c) {
      x(this, n), i.search(/^[0-9]{12}$/) !== -1 && (i += e(i));
      var u = s(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, i, c));
      return u.lastChar = c.lastChar, u;
    }
    return d(n, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === e(this.data);
      }
    }, {
      key: "leftText",
      value: function() {
        return f(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "leftText", this).call(this, 1, 6);
      }
    }, {
      key: "leftEncode",
      value: function() {
        var c = this.data.substr(1, 6), u = v.EAN13_STRUCTURE[this.data[0]];
        return f(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "leftEncode", this).call(this, c, u);
      }
    }, {
      key: "rightText",
      value: function() {
        return f(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "rightText", this).call(this, 7, 6);
      }
    }, {
      key: "rightEncode",
      value: function() {
        var c = this.data.substr(7, 6);
        return f(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "rightEncode", this).call(this, c, "RRRRRR");
      }
      // The "standard" way of printing EAN13 barcodes with guard bars
    }, {
      key: "encodeGuarded",
      value: function() {
        var c = f(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "encodeGuarded", this).call(this);
        return this.options.displayValue && (c.unshift({
          data: "000000000000",
          text: this.text.substr(0, 1),
          options: { textAlign: "left", fontSize: this.fontSize }
        }), this.options.lastChar && (c.push({
          data: "00"
        }), c.push({
          data: "00000",
          text: this.options.lastChar,
          options: { fontSize: this.fontSize }
        }))), c;
      }
    }]), n;
  })(y.default);
  return He.default = t, He;
}
var Ue = {}, Ut;
function on() {
  if (Ut) return Ue;
  Ut = 1, Object.defineProperty(Ue, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function t(o, n) {
      for (var i = 0; i < n.length; i++) {
        var c = n[i];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(o, c.key, c);
      }
    }
    return function(o, n, i) {
      return n && t(o.prototype, n), i && t(o, i), o;
    };
  })(), f = function t(o, n, i) {
    o === null && (o = Function.prototype);
    var c = Object.getOwnPropertyDescriptor(o, n);
    if (c === void 0) {
      var u = Object.getPrototypeOf(o);
      return u === null ? void 0 : t(u, n, i);
    } else {
      if ("value" in c)
        return c.value;
      var _ = c.get;
      return _ === void 0 ? void 0 : _.call(i);
    }
  }, v = Nr(), h = y(v);
  function y(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function p(t, o) {
    if (!(t instanceof o))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(t, o) {
    if (!t)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return o && (typeof o == "object" || typeof o == "function") ? o : t;
  }
  function s(t, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof o);
    t.prototype = Object.create(o && o.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(t, o) : t.__proto__ = o);
  }
  var l = function(o) {
    var n = o.substr(0, 7).split("").map(function(i) {
      return +i;
    }).reduce(function(i, c, u) {
      return u % 2 ? i + c : i + c * 3;
    }, 0);
    return (10 - n % 10) % 10;
  }, e = (function(t) {
    s(o, t);
    function o(n, i) {
      return p(this, o), n.search(/^[0-9]{7}$/) !== -1 && (n += l(n)), x(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, i));
    }
    return d(o, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === l(this.data);
      }
    }, {
      key: "leftText",
      value: function() {
        return f(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftText", this).call(this, 0, 4);
      }
    }, {
      key: "leftEncode",
      value: function() {
        var i = this.data.substr(0, 4);
        return f(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftEncode", this).call(this, i, "LLLL");
      }
    }, {
      key: "rightText",
      value: function() {
        return f(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightText", this).call(this, 4, 4);
      }
    }, {
      key: "rightEncode",
      value: function() {
        var i = this.data.substr(4, 4);
        return f(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightEncode", this).call(this, i, "RRRR");
      }
    }]), o;
  })(h.default);
  return Ue.default = e, Ue;
}
var Ge = {}, Gt;
function an() {
  if (Gt) return Ge;
  Gt = 1, Object.defineProperty(Ge, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function n(i, c) {
      for (var u = 0; u < c.length; u++) {
        var _ = c[u];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
      }
    }
    return function(i, c, u) {
      return c && n(i.prototype, c), u && n(i, u), i;
    };
  })(), f = Te(), v = De(), h = x(v), y = K(), p = x(y);
  function x(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function s(n, i) {
    if (!(n instanceof i))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(n, i) {
    if (!n)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return i && (typeof i == "object" || typeof i == "function") ? i : n;
  }
  function e(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof i);
    n.prototype = Object.create(i && i.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(n, i) : n.__proto__ = i);
  }
  var t = function(i) {
    var c = i.split("").map(function(u) {
      return +u;
    }).reduce(function(u, _, S) {
      return S % 2 ? u + _ * 9 : u + _ * 3;
    }, 0);
    return c % 10;
  }, o = (function(n) {
    e(i, n);
    function i(c, u) {
      return s(this, i), l(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, c, u));
    }
    return d(i, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{5}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var u = f.EAN5_STRUCTURE[t(this.data)];
        return {
          data: "1011" + (0, h.default)(this.data, u, "01"),
          text: this.text
        };
      }
    }]), i;
  })(p.default);
  return Ge.default = o, Ge;
}
var Xe = {}, Xt;
function ln() {
  if (Xt) return Xe;
  Xt = 1, Object.defineProperty(Xe, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function o(n, i) {
      for (var c = 0; c < i.length; c++) {
        var u = i[c];
        u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(n, u.key, u);
      }
    }
    return function(n, i, c) {
      return i && o(n.prototype, i), c && o(n, c), n;
    };
  })(), f = Te(), v = De(), h = x(v), y = K(), p = x(y);
  function x(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function s(o, n) {
    if (!(o instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(o, n) {
    if (!o)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : o;
  }
  function e(o, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    o.prototype = Object.create(n && n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(o, n) : o.__proto__ = n);
  }
  var t = (function(o) {
    e(n, o);
    function n(i, c) {
      return s(this, n), l(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, i, c));
    }
    return d(n, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{2}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var c = f.EAN2_STRUCTURE[parseInt(this.data) % 4];
        return {
          // Start bits + Encode the two digits with 01 in between
          data: "1011" + (0, h.default)(this.data, c, "01"),
          text: this.text
        };
      }
    }]), n;
  })(p.default);
  return Xe.default = t, Xe;
}
var ve = {}, Zt;
function Mr() {
  if (Zt) return ve;
  Zt = 1, Object.defineProperty(ve, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function o(n, i) {
      for (var c = 0; c < i.length; c++) {
        var u = i[c];
        u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(n, u.key, u);
      }
    }
    return function(n, i, c) {
      return i && o(n.prototype, i), c && o(n, c), n;
    };
  })();
  ve.checksum = t;
  var f = De(), v = p(f), h = K(), y = p(h);
  function p(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function x(o, n) {
    if (!(o instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(o, n) {
    if (!o)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n && (typeof n == "object" || typeof n == "function") ? n : o;
  }
  function l(o, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    o.prototype = Object.create(n && n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(o, n) : o.__proto__ = n);
  }
  var e = (function(o) {
    l(n, o);
    function n(i, c) {
      x(this, n), i.search(/^[0-9]{11}$/) !== -1 && (i += t(i));
      var u = s(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, i, c));
      return u.displayValue = c.displayValue, c.fontSize > c.width * 10 ? u.fontSize = c.width * 10 : u.fontSize = c.fontSize, u.guardHeight = c.height + u.fontSize / 2 + c.textMargin, u;
    }
    return d(n, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == t(this.data);
      }
    }, {
      key: "encode",
      value: function() {
        return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
      }
    }, {
      key: "flatEncoding",
      value: function() {
        var c = "";
        return c += "101", c += (0, v.default)(this.data.substr(0, 6), "LLLLLL"), c += "01010", c += (0, v.default)(this.data.substr(6, 6), "RRRRRR"), c += "101", {
          data: c,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function() {
        var c = [];
        return this.displayValue && c.push({
          data: "00000000",
          text: this.text.substr(0, 1),
          options: { textAlign: "left", fontSize: this.fontSize }
        }), c.push({
          data: "101" + (0, v.default)(this.data[0], "L"),
          options: { height: this.guardHeight }
        }), c.push({
          data: (0, v.default)(this.data.substr(1, 5), "LLLLL"),
          text: this.text.substr(1, 5),
          options: { fontSize: this.fontSize }
        }), c.push({
          data: "01010",
          options: { height: this.guardHeight }
        }), c.push({
          data: (0, v.default)(this.data.substr(6, 5), "RRRRR"),
          text: this.text.substr(6, 5),
          options: { fontSize: this.fontSize }
        }), c.push({
          data: (0, v.default)(this.data[11], "R") + "101",
          options: { height: this.guardHeight }
        }), this.displayValue && c.push({
          data: "00000000",
          text: this.text.substr(11, 1),
          options: { textAlign: "right", fontSize: this.fontSize }
        }), c;
      }
    }]), n;
  })(y.default);
  function t(o) {
    var n = 0, i;
    for (i = 1; i < 11; i += 2)
      n += parseInt(o[i]);
    for (i = 0; i < 11; i += 2)
      n += parseInt(o[i]) * 3;
    return (10 - n % 10) % 10;
  }
  return ve.default = e, ve;
}
var Ze = {}, Kt;
function cn() {
  if (Kt) return Ze;
  Kt = 1, Object.defineProperty(Ze, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function c(u, _) {
      for (var S = 0; S < _.length; S++) {
        var R = _[S];
        R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(u, R.key, R);
      }
    }
    return function(u, _, S) {
      return _ && c(u.prototype, _), S && c(u, S), u;
    };
  })(), f = De(), v = x(f), h = K(), y = x(h), p = Mr();
  function x(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function s(c, u) {
    if (!(c instanceof u))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(c, u) {
    if (!c)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return u && (typeof u == "object" || typeof u == "function") ? u : c;
  }
  function e(c, u) {
    if (typeof u != "function" && u !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof u);
    c.prototype = Object.create(u && u.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), u && (Object.setPrototypeOf ? Object.setPrototypeOf(c, u) : c.__proto__ = u);
  }
  var t = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"], o = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]], n = (function(c) {
    e(u, c);
    function u(_, S) {
      s(this, u);
      var R = l(this, (u.__proto__ || Object.getPrototypeOf(u)).call(this, _, S));
      if (R.isValid = !1, _.search(/^[0-9]{6}$/) !== -1)
        R.middleDigits = _, R.upcA = i(_, "0"), R.text = S.text || "" + R.upcA[0] + _ + R.upcA[R.upcA.length - 1], R.isValid = !0;
      else if (_.search(/^[01][0-9]{7}$/) !== -1)
        if (R.middleDigits = _.substring(1, _.length - 1), R.upcA = i(R.middleDigits, _[0]), R.upcA[R.upcA.length - 1] === _[_.length - 1])
          R.isValid = !0;
        else
          return l(R);
      else
        return l(R);
      return R.displayValue = S.displayValue, S.fontSize > S.width * 10 ? R.fontSize = S.width * 10 : R.fontSize = S.fontSize, R.guardHeight = S.height + R.fontSize / 2 + S.textMargin, R;
    }
    return d(u, [{
      key: "valid",
      value: function() {
        return this.isValid;
      }
    }, {
      key: "encode",
      value: function() {
        return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
      }
    }, {
      key: "flatEncoding",
      value: function() {
        var S = "";
        return S += "101", S += this.encodeMiddleDigits(), S += "010101", {
          data: S,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function() {
        var S = [];
        return this.displayValue && S.push({
          data: "00000000",
          text: this.text[0],
          options: { textAlign: "left", fontSize: this.fontSize }
        }), S.push({
          data: "101",
          options: { height: this.guardHeight }
        }), S.push({
          data: this.encodeMiddleDigits(),
          text: this.text.substring(1, 7),
          options: { fontSize: this.fontSize }
        }), S.push({
          data: "010101",
          options: { height: this.guardHeight }
        }), this.displayValue && S.push({
          data: "00000000",
          text: this.text[7],
          options: { textAlign: "right", fontSize: this.fontSize }
        }), S;
      }
    }, {
      key: "encodeMiddleDigits",
      value: function() {
        var S = this.upcA[0], R = this.upcA[this.upcA.length - 1], C = o[parseInt(R)][parseInt(S)];
        return (0, v.default)(this.middleDigits, C);
      }
    }]), u;
  })(y.default);
  function i(c, u) {
    for (var _ = parseInt(c[c.length - 1]), S = t[_], R = "", C = 0, U = 0; U < S.length; U++) {
      var Q = S[U];
      Q === "X" ? R += c[C++] : R += Q;
    }
    return R = "" + u + R, "" + R + (0, p.checksum)(R);
  }
  return Ze.default = n, Ze;
}
var Yt;
function un() {
  if (Yt) return V;
  Yt = 1, Object.defineProperty(V, "__esModule", {
    value: !0
  }), V.UPCE = V.UPC = V.EAN2 = V.EAN5 = V.EAN8 = V.EAN13 = void 0;
  var d = nn(), f = n(d), v = on(), h = n(v), y = an(), p = n(y), x = ln(), s = n(x), l = Mr(), e = n(l), t = cn(), o = n(t);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  return V.EAN13 = f.default, V.EAN8 = h.default, V.EAN5 = p.default, V.EAN2 = s.default, V.UPC = e.default, V.UPCE = o.default, V;
}
var ie = {}, Ke = {}, fe = {}, Jt;
function sn() {
  return Jt || (Jt = 1, Object.defineProperty(fe, "__esModule", {
    value: !0
  }), fe.START_BIN = "1010", fe.END_BIN = "11101", fe.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"]), fe;
}
var Qt;
function Fr() {
  if (Qt) return Ke;
  Qt = 1, Object.defineProperty(Ke, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = sn(), v = K(), h = y(v);
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t() {
      return p(this, t), x(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return this.data.search(/^([0-9]{2})+$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        var n = this, i = this.data.match(/.{2}/g).map(function(c) {
          return n.encodePair(c);
        }).join("");
        return {
          data: f.START_BIN + i + f.END_BIN,
          text: this.text
        };
      }
      // Calculate the data of a number pair
    }, {
      key: "encodePair",
      value: function(n) {
        var i = f.BINARIES[n[1]];
        return f.BINARIES[n[0]].split("").map(function(c, u) {
          return (c === "1" ? "111" : "1") + (i[u] === "1" ? "000" : "0");
        }).join("");
      }
    }]), t;
  })(h.default);
  return Ke.default = l, Ke;
}
var Ye = {}, $t;
function dn() {
  if ($t) return Ye;
  $t = 1, Object.defineProperty(Ye, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = Fr(), v = h(f);
  function h(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function y(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function x(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var s = function(t) {
    var o = t.substr(0, 13).split("").map(function(n) {
      return parseInt(n, 10);
    }).reduce(function(n, i, c) {
      return n + i * (3 - c % 2 * 2);
    }, 0);
    return Math.ceil(o / 10) * 10 - o;
  }, l = (function(e) {
    x(t, e);
    function t(o, n) {
      return y(this, t), o.search(/^[0-9]{13}$/) !== -1 && (o += s(o)), p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, o, n));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === s(this.data);
      }
    }]), t;
  })(v.default);
  return Ye.default = l, Ye;
}
var er;
function fn() {
  if (er) return ie;
  er = 1, Object.defineProperty(ie, "__esModule", {
    value: !0
  }), ie.ITF14 = ie.ITF = void 0;
  var d = Fr(), f = y(d), v = dn(), h = y(v);
  function y(p) {
    return p && p.__esModule ? p : { default: p };
  }
  return ie.ITF = f.default, ie.ITF14 = h.default, ie;
}
var G = {}, Je = {}, tr;
function Ae() {
  if (tr) return Je;
  tr = 1, Object.defineProperty(Je, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = K(), v = h(f);
  function h(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function y(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function x(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var s = (function(e) {
    x(t, e);
    function t(o, n) {
      return y(this, t), p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, o, n));
    }
    return d(t, [{
      key: "encode",
      value: function() {
        for (var n = "110", i = 0; i < this.data.length; i++) {
          var c = parseInt(this.data[i]), u = c.toString(2);
          u = l(u, 4 - u.length);
          for (var _ = 0; _ < u.length; _++)
            n += u[_] == "0" ? "100" : "110";
        }
        return n += "1001", {
          data: n,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.data.search(/^[0-9]+$/) !== -1;
      }
    }]), t;
  })(v.default);
  function l(e, t) {
    for (var o = 0; o < t; o++)
      e = "0" + e;
    return e;
  }
  return Je.default = s, Je;
}
var Qe = {}, be = {}, rr;
function vt() {
  if (rr) return be;
  rr = 1, Object.defineProperty(be, "__esModule", {
    value: !0
  }), be.mod10 = d, be.mod11 = f;
  function d(v) {
    for (var h = 0, y = 0; y < v.length; y++) {
      var p = parseInt(v[y]);
      (y + v.length) % 2 === 0 ? h += p : h += p * 2 % 10 + Math.floor(p * 2 / 10);
    }
    return (10 - h % 10) % 10;
  }
  function f(v) {
    for (var h = 0, y = [2, 3, 4, 5, 6, 7], p = 0; p < v.length; p++) {
      var x = parseInt(v[v.length - 1 - p]);
      h += y[p % y.length] * x;
    }
    return (11 - h % 11) % 11;
  }
  return be;
}
var nr;
function hn() {
  if (nr) return Qe;
  nr = 1, Object.defineProperty(Qe, "__esModule", {
    value: !0
  });
  var d = Ae(), f = h(d), v = vt();
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t + (0, v.mod10)(t), o));
    }
    return e;
  })(f.default);
  return Qe.default = s, Qe;
}
var $e = {}, or;
function xn() {
  if (or) return $e;
  or = 1, Object.defineProperty($e, "__esModule", {
    value: !0
  });
  var d = Ae(), f = h(d), v = vt();
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t + (0, v.mod11)(t), o));
    }
    return e;
  })(f.default);
  return $e.default = s, $e;
}
var et = {}, ir;
function yn() {
  if (ir) return et;
  ir = 1, Object.defineProperty(et, "__esModule", {
    value: !0
  });
  var d = Ae(), f = h(d), v = vt();
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), t += (0, v.mod10)(t), t += (0, v.mod10)(t), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, o));
    }
    return e;
  })(f.default);
  return et.default = s, et;
}
var tt = {}, ar;
function gn() {
  if (ar) return tt;
  ar = 1, Object.defineProperty(tt, "__esModule", {
    value: !0
  });
  var d = Ae(), f = h(d), v = vt();
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), t += (0, v.mod11)(t), t += (0, v.mod10)(t), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, o));
    }
    return e;
  })(f.default);
  return tt.default = s, tt;
}
var lr;
function mn() {
  if (lr) return G;
  lr = 1, Object.defineProperty(G, "__esModule", {
    value: !0
  }), G.MSI1110 = G.MSI1010 = G.MSI11 = G.MSI10 = G.MSI = void 0;
  var d = Ae(), f = t(d), v = hn(), h = t(v), y = xn(), p = t(y), x = yn(), s = t(x), l = gn(), e = t(l);
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  return G.MSI = f.default, G.MSI10 = h.default, G.MSI11 = p.default, G.MSI1010 = s.default, G.MSI1110 = e.default, G;
}
var _e = {}, cr;
function pn() {
  if (cr) return _e;
  cr = 1, Object.defineProperty(_e, "__esModule", {
    value: !0
  }), _e.pharmacode = void 0;
  var d = /* @__PURE__ */ (function() {
    function l(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function(e, t, o) {
      return t && l(e.prototype, t), o && l(e, o), e;
    };
  })(), f = K(), v = h(f);
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      y(this, e);
      var n = p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, o));
      return n.number = parseInt(t, 10), n;
    }
    return d(e, [{
      key: "encode",
      value: function() {
        for (var o = this.number, n = ""; !isNaN(o) && o != 0; )
          o % 2 === 0 ? (n = "11100" + n, o = (o - 2) / 2) : (n = "100" + n, o = (o - 1) / 2);
        return n = n.slice(0, -2), {
          data: n,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function() {
        return this.number >= 3 && this.number <= 131070;
      }
    }]), e;
  })(v.default);
  return _e.pharmacode = s, _e;
}
var Se = {}, ur;
function vn() {
  if (ur) return Se;
  ur = 1, Object.defineProperty(Se, "__esModule", {
    value: !0
  }), Se.codabar = void 0;
  var d = /* @__PURE__ */ (function() {
    function l(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function(e, t, o) {
      return t && l(e.prototype, t), o && l(e, o), e;
    };
  })(), f = K(), v = h(f);
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      y(this, e), t.search(/^[0-9\-\$\:\.\+\/]+$/) === 0 && (t = "A" + t + "A");
      var n = p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t.toUpperCase(), o));
      return n.text = n.options.text || n.text.replace(/[A-D]/g, ""), n;
    }
    return d(e, [{
      key: "valid",
      value: function() {
        return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
      }
    }, {
      key: "encode",
      value: function() {
        for (var o = [], n = this.getEncodings(), i = 0; i < this.data.length; i++)
          o.push(n[this.data.charAt(i)]), i !== this.data.length - 1 && o.push("0");
        return {
          text: this.text,
          data: o.join("")
        };
      }
    }, {
      key: "getEncodings",
      value: function() {
        return {
          0: "101010011",
          1: "101011001",
          2: "101001011",
          3: "110010101",
          4: "101101001",
          5: "110101001",
          6: "100101011",
          7: "100101101",
          8: "100110101",
          9: "110100101",
          "-": "101001101",
          $: "101100101",
          ":": "1101011011",
          "/": "1101101011",
          ".": "1101101101",
          "+": "1011011011",
          A: "1011001001",
          B: "1001001011",
          C: "1010010011",
          D: "1010011001"
        };
      }
    }]), e;
  })(v.default);
  return Se.codabar = s, Se;
}
var ae = {}, rt = {}, he = {}, sr;
function bn() {
  return sr || (sr = 1, Object.defineProperty(he, "__esModule", {
    value: !0
  }), he.SYMBOLS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "-",
    ".",
    " ",
    "$",
    "/",
    "+",
    "%",
    // Only used for csum and multi-symbols character encodings
    "($)",
    "(%)",
    "(/)",
    "(+)",
    // Start/Stop
    "ÿ"
  ], he.BINARIES = ["100010100", "101001000", "101000100", "101000010", "100101000", "100100100", "100100010", "101010000", "100010010", "100001010", "110101000", "110100100", "110100010", "110010100", "110010010", "110001010", "101101000", "101100100", "101100010", "100110100", "100011010", "101011000", "101001100", "101000110", "100101100", "100010110", "110110100", "110110010", "110101100", "110100110", "110010110", "110011010", "101101100", "101100110", "100110110", "100111010", "100101110", "111010100", "111010010", "111001010", "101101110", "101110110", "110101110", "100100110", "111011010", "111010110", "100110010", "101011110"], he.MULTI_SYMBOLS = {
    "\0": ["(%)", "U"],
    "": ["($)", "A"],
    "": ["($)", "B"],
    "": ["($)", "C"],
    "": ["($)", "D"],
    "": ["($)", "E"],
    "": ["($)", "F"],
    "\x07": ["($)", "G"],
    "\b": ["($)", "H"],
    "	": ["($)", "I"],
    "\n": ["($)", "J"],
    "\v": ["($)", "K"],
    "\f": ["($)", "L"],
    "\r": ["($)", "M"],
    "": ["($)", "N"],
    "": ["($)", "O"],
    "": ["($)", "P"],
    "": ["($)", "Q"],
    "": ["($)", "R"],
    "": ["($)", "S"],
    "": ["($)", "T"],
    "": ["($)", "U"],
    "": ["($)", "V"],
    "": ["($)", "W"],
    "": ["($)", "X"],
    "": ["($)", "Y"],
    "": ["($)", "Z"],
    "\x1B": ["(%)", "A"],
    "": ["(%)", "B"],
    "": ["(%)", "C"],
    "": ["(%)", "D"],
    "": ["(%)", "E"],
    "!": ["(/)", "A"],
    '"': ["(/)", "B"],
    "#": ["(/)", "C"],
    "&": ["(/)", "F"],
    "'": ["(/)", "G"],
    "(": ["(/)", "H"],
    ")": ["(/)", "I"],
    "*": ["(/)", "J"],
    ",": ["(/)", "L"],
    ":": ["(/)", "Z"],
    ";": ["(%)", "F"],
    "<": ["(%)", "G"],
    "=": ["(%)", "H"],
    ">": ["(%)", "I"],
    "?": ["(%)", "J"],
    "@": ["(%)", "V"],
    "[": ["(%)", "K"],
    "\\": ["(%)", "L"],
    "]": ["(%)", "M"],
    "^": ["(%)", "N"],
    _: ["(%)", "O"],
    "`": ["(%)", "W"],
    a: ["(+)", "A"],
    b: ["(+)", "B"],
    c: ["(+)", "C"],
    d: ["(+)", "D"],
    e: ["(+)", "E"],
    f: ["(+)", "F"],
    g: ["(+)", "G"],
    h: ["(+)", "H"],
    i: ["(+)", "I"],
    j: ["(+)", "J"],
    k: ["(+)", "K"],
    l: ["(+)", "L"],
    m: ["(+)", "M"],
    n: ["(+)", "N"],
    o: ["(+)", "O"],
    p: ["(+)", "P"],
    q: ["(+)", "Q"],
    r: ["(+)", "R"],
    s: ["(+)", "S"],
    t: ["(+)", "T"],
    u: ["(+)", "U"],
    v: ["(+)", "V"],
    w: ["(+)", "W"],
    x: ["(+)", "X"],
    y: ["(+)", "Y"],
    z: ["(+)", "Z"],
    "{": ["(%)", "P"],
    "|": ["(%)", "Q"],
    "}": ["(%)", "R"],
    "~": ["(%)", "S"],
    "": ["(%)", "T"]
  }), he;
}
var dr;
function Lr() {
  if (dr) return rt;
  dr = 1, Object.defineProperty(rt, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function e(t, o) {
      for (var n = 0; n < o.length; n++) {
        var i = o[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    return function(t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  })(), f = bn(), v = K(), h = y(v);
  function y(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function p(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    if (!e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t && (typeof t == "object" || typeof t == "function") ? t : e;
  }
  function s(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }
  var l = (function(e) {
    s(t, e);
    function t(o, n) {
      return p(this, t), x(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, o, n));
    }
    return d(t, [{
      key: "valid",
      value: function() {
        return /^[0-9A-Z\-. $/+%]+$/.test(this.data);
      }
    }, {
      key: "encode",
      value: function() {
        var n = this.data.split("").flatMap(function(_) {
          return f.MULTI_SYMBOLS[_] || _;
        }), i = n.map(function(_) {
          return t.getEncoding(_);
        }).join(""), c = t.checksum(n, 20), u = t.checksum(n.concat(c), 15);
        return {
          text: this.text,
          data: (
            // Add the start bits
            t.getEncoding("ÿ") + // Add the encoded bits
            i + // Add the checksum
            t.getEncoding(c) + t.getEncoding(u) + // Add the stop bits
            t.getEncoding("ÿ") + // Add the termination bit
            "1"
          )
        };
      }
      // Get the binary encoding of a symbol
    }], [{
      key: "getEncoding",
      value: function(n) {
        return f.BINARIES[t.symbolValue(n)];
      }
      // Get the symbol for a symbol value
    }, {
      key: "getSymbol",
      value: function(n) {
        return f.SYMBOLS[n];
      }
      // Get the symbol value of a symbol
    }, {
      key: "symbolValue",
      value: function(n) {
        return f.SYMBOLS.indexOf(n);
      }
      // Calculate a checksum symbol
    }, {
      key: "checksum",
      value: function(n, i) {
        var c = n.slice().reverse().reduce(function(u, _, S) {
          var R = S % i + 1;
          return u + t.symbolValue(_) * R;
        }, 0);
        return t.getSymbol(c % 47);
      }
    }]), t;
  })(h.default);
  return rt.default = l, rt;
}
var nt = {}, fr;
function _n() {
  if (fr) return nt;
  fr = 1, Object.defineProperty(nt, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function l(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function(e, t, o) {
      return t && l(e.prototype, t), o && l(e, o), e;
    };
  })(), f = Lr(), v = h(f);
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, o));
    }
    return d(e, [{
      key: "valid",
      value: function() {
        return /^[\x00-\x7f]+$/.test(this.data);
      }
    }]), e;
  })(v.default);
  return nt.default = s, nt;
}
var hr;
function Sn() {
  if (hr) return ae;
  hr = 1, Object.defineProperty(ae, "__esModule", {
    value: !0
  }), ae.CODE93FullASCII = ae.CODE93 = void 0;
  var d = Lr(), f = y(d), v = _n(), h = y(v);
  function y(p) {
    return p && p.__esModule ? p : { default: p };
  }
  return ae.CODE93 = f.default, ae.CODE93FullASCII = h.default, ae;
}
var je = {}, xr;
function jn() {
  if (xr) return je;
  xr = 1, Object.defineProperty(je, "__esModule", {
    value: !0
  }), je.GenericBarcode = void 0;
  var d = /* @__PURE__ */ (function() {
    function l(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function(e, t, o) {
      return t && l(e.prototype, t), o && l(e, o), e;
    };
  })(), f = K(), v = h(f);
  function h(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function y(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(l, e) {
    if (!l)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : l;
  }
  function x(l, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
  }
  var s = (function(l) {
    x(e, l);
    function e(t, o) {
      return y(this, e), p(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, o));
    }
    return d(e, [{
      key: "encode",
      value: function() {
        return {
          data: "10101010101010101010101010101010101010101",
          text: this.text
        };
      }
      // Resturn true/false if the string provided is valid for this encoder
    }, {
      key: "valid",
      value: function() {
        return !0;
      }
    }]), e;
  })(v.default);
  return je.GenericBarcode = s, je;
}
var yr;
function wn() {
  if (yr) return Ie;
  yr = 1, Object.defineProperty(Ie, "__esModule", {
    value: !0
  });
  var d = Yr(), f = rn(), v = un(), h = fn(), y = mn(), p = pn(), x = vn(), s = Sn(), l = jn();
  return Ie.default = {
    CODE39: d.CODE39,
    CODE128: f.CODE128,
    CODE128A: f.CODE128A,
    CODE128B: f.CODE128B,
    CODE128C: f.CODE128C,
    EAN13: v.EAN13,
    EAN8: v.EAN8,
    EAN5: v.EAN5,
    EAN2: v.EAN2,
    UPC: v.UPC,
    UPCE: v.UPCE,
    ITF14: h.ITF14,
    ITF: h.ITF,
    MSI: y.MSI,
    MSI10: y.MSI10,
    MSI11: y.MSI11,
    MSI1010: y.MSI1010,
    MSI1110: y.MSI1110,
    pharmacode: p.pharmacode,
    codabar: x.codabar,
    CODE93: s.CODE93,
    CODE93FullASCII: s.CODE93FullASCII,
    GenericBarcode: l.GenericBarcode
  }, Ie;
}
var ot = {}, gr;
function bt() {
  if (gr) return ot;
  gr = 1, Object.defineProperty(ot, "__esModule", {
    value: !0
  });
  var d = Object.assign || function(f) {
    for (var v = 1; v < arguments.length; v++) {
      var h = arguments[v];
      for (var y in h)
        Object.prototype.hasOwnProperty.call(h, y) && (f[y] = h[y]);
    }
    return f;
  };
  return ot.default = function(f, v) {
    return d({}, f, v);
  }, ot;
}
var it = {}, mr;
function Rn() {
  if (mr) return it;
  mr = 1, Object.defineProperty(it, "__esModule", {
    value: !0
  }), it.default = d;
  function d(f) {
    var v = [];
    function h(y) {
      if (Array.isArray(y))
        for (var p = 0; p < y.length; p++)
          h(y[p]);
      else
        y.text = y.text || "", y.data = y.data || "", v.push(y);
    }
    return h(f), v;
  }
  return it;
}
var at = {}, pr;
function En() {
  if (pr) return at;
  pr = 1, Object.defineProperty(at, "__esModule", {
    value: !0
  }), at.default = d;
  function d(f) {
    return f.marginTop = f.marginTop || f.margin, f.marginBottom = f.marginBottom || f.margin, f.marginRight = f.marginRight || f.margin, f.marginLeft = f.marginLeft || f.margin, f;
  }
  return at;
}
var lt = {}, ct = {}, ut = {}, vr;
function zr() {
  if (vr) return ut;
  vr = 1, Object.defineProperty(ut, "__esModule", {
    value: !0
  }), ut.default = d;
  function d(f) {
    var v = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
    for (var h in v)
      v.hasOwnProperty(h) && (h = v[h], typeof f[h] == "string" && (f[h] = parseInt(f[h], 10)));
    return typeof f.displayValue == "string" && (f.displayValue = f.displayValue != "false"), f;
  }
  return ut;
}
var st = {}, br;
function qr() {
  if (br) return st;
  br = 1, Object.defineProperty(st, "__esModule", {
    value: !0
  });
  var d = {
    width: 2,
    height: 100,
    format: "auto",
    displayValue: !0,
    fontOptions: "",
    font: "monospace",
    text: void 0,
    textAlign: "center",
    textPosition: "bottom",
    textMargin: 2,
    fontSize: 20,
    background: "#ffffff",
    lineColor: "#000000",
    margin: 10,
    marginTop: void 0,
    marginBottom: void 0,
    marginLeft: void 0,
    marginRight: void 0,
    valid: function() {
    }
  };
  return st.default = d, st;
}
var _r;
function On() {
  if (_r) return ct;
  _r = 1, Object.defineProperty(ct, "__esModule", {
    value: !0
  });
  var d = zr(), f = y(d), v = qr(), h = y(v);
  function y(x) {
    return x && x.__esModule ? x : { default: x };
  }
  function p(x) {
    var s = {};
    for (var l in h.default)
      h.default.hasOwnProperty(l) && (x.hasAttribute("jsbarcode-" + l.toLowerCase()) && (s[l] = x.getAttribute("jsbarcode-" + l.toLowerCase())), x.hasAttribute("data-" + l.toLowerCase()) && (s[l] = x.getAttribute("data-" + l.toLowerCase())));
    return s.value = x.getAttribute("jsbarcode-value") || x.getAttribute("data-value"), s = (0, f.default)(s), s;
  }
  return ct.default = p, ct;
}
var dt = {}, ft = {}, X = {}, Sr;
function Hr() {
  if (Sr) return X;
  Sr = 1, Object.defineProperty(X, "__esModule", {
    value: !0
  }), X.getTotalWidthOfEncodings = X.calculateEncodingAttributes = X.getBarcodePadding = X.getEncodingHeight = X.getMaximumHeightOfEncodings = void 0;
  var d = bt(), f = v(d);
  function v(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function h(e, t) {
    return t.height + (t.displayValue && e.text.length > 0 ? t.fontSize + t.textMargin : 0) + t.marginTop + t.marginBottom;
  }
  function y(e, t, o) {
    if (o.displayValue && t < e) {
      if (o.textAlign == "center")
        return Math.floor((e - t) / 2);
      if (o.textAlign == "left")
        return 0;
      if (o.textAlign == "right")
        return Math.floor(e - t);
    }
    return 0;
  }
  function p(e, t, o) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n], c = (0, f.default)(t, i.options), u;
      c.displayValue ? u = l(i.text, c, o) : u = 0;
      var _ = i.data.length * c.width;
      i.width = Math.ceil(Math.max(u, _)), i.height = h(i, c), i.barcodePadding = y(u, _, c);
    }
  }
  function x(e) {
    for (var t = 0, o = 0; o < e.length; o++)
      t += e[o].width;
    return t;
  }
  function s(e) {
    for (var t = 0, o = 0; o < e.length; o++)
      e[o].height > t && (t = e[o].height);
    return t;
  }
  function l(e, t, o) {
    var n;
    if (o)
      n = o;
    else if (typeof document < "u")
      n = document.createElement("canvas").getContext("2d");
    else
      return 0;
    n.font = t.fontOptions + " " + t.fontSize + "px " + t.font;
    var i = n.measureText(e);
    if (!i)
      return 0;
    var c = i.width;
    return c;
  }
  return X.getMaximumHeightOfEncodings = s, X.getEncodingHeight = h, X.getBarcodePadding = y, X.calculateEncodingAttributes = p, X.getTotalWidthOfEncodings = x, X;
}
var jr;
function Tn() {
  if (jr) return ft;
  jr = 1, Object.defineProperty(ft, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function s(l, e) {
      for (var t = 0; t < e.length; t++) {
        var o = e[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(l, o.key, o);
      }
    }
    return function(l, e, t) {
      return e && s(l.prototype, e), t && s(l, t), l;
    };
  })(), f = bt(), v = y(f), h = Hr();
  function y(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function p(s, l) {
    if (!(s instanceof l))
      throw new TypeError("Cannot call a class as a function");
  }
  var x = (function() {
    function s(l, e, t) {
      p(this, s), this.canvas = l, this.encodings = e, this.options = t;
    }
    return d(s, [{
      key: "render",
      value: function() {
        if (!this.canvas.getContext)
          throw new Error("The browser does not support canvas.");
        this.prepareCanvas();
        for (var e = 0; e < this.encodings.length; e++) {
          var t = (0, v.default)(this.options, this.encodings[e].options);
          this.drawCanvasBarcode(t, this.encodings[e]), this.drawCanvasText(t, this.encodings[e]), this.moveCanvasDrawing(this.encodings[e]);
        }
        this.restoreCanvas();
      }
    }, {
      key: "prepareCanvas",
      value: function() {
        var e = this.canvas.getContext("2d");
        e.save(), (0, h.calculateEncodingAttributes)(this.encodings, this.options, e);
        var t = (0, h.getTotalWidthOfEncodings)(this.encodings), o = (0, h.getMaximumHeightOfEncodings)(this.encodings);
        this.canvas.width = t + this.options.marginLeft + this.options.marginRight, this.canvas.height = o, e.clearRect(0, 0, this.canvas.width, this.canvas.height), this.options.background && (e.fillStyle = this.options.background, e.fillRect(0, 0, this.canvas.width, this.canvas.height)), e.translate(this.options.marginLeft, 0);
      }
    }, {
      key: "drawCanvasBarcode",
      value: function(e, t) {
        var o = this.canvas.getContext("2d"), n = t.data, i;
        e.textPosition == "top" ? i = e.marginTop + e.fontSize + e.textMargin : i = e.marginTop, o.fillStyle = e.lineColor;
        for (var c = 0; c < n.length; c++) {
          var u = c * e.width + t.barcodePadding;
          n[c] === "1" ? o.fillRect(u, i, e.width, e.height) : n[c] && o.fillRect(u, i, e.width, e.height * n[c]);
        }
      }
    }, {
      key: "drawCanvasText",
      value: function(e, t) {
        var o = this.canvas.getContext("2d"), n = e.fontOptions + " " + e.fontSize + "px " + e.font;
        if (e.displayValue) {
          var i, c;
          e.textPosition == "top" ? c = e.marginTop + e.fontSize - e.textMargin : c = e.height + e.textMargin + e.marginTop + e.fontSize, o.font = n, e.textAlign == "left" || t.barcodePadding > 0 ? (i = 0, o.textAlign = "left") : e.textAlign == "right" ? (i = t.width - 1, o.textAlign = "right") : (i = t.width / 2, o.textAlign = "center"), o.fillText(t.text, i, c);
        }
      }
    }, {
      key: "moveCanvasDrawing",
      value: function(e) {
        var t = this.canvas.getContext("2d");
        t.translate(e.width, 0);
      }
    }, {
      key: "restoreCanvas",
      value: function() {
        var e = this.canvas.getContext("2d");
        e.restore();
      }
    }]), s;
  })();
  return ft.default = x, ft;
}
var ht = {}, wr;
function Dn() {
  if (wr) return ht;
  wr = 1, Object.defineProperty(ht, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function l(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function(e, t, o) {
      return t && l(e.prototype, t), o && l(e, o), e;
    };
  })(), f = bt(), v = y(f), h = Hr();
  function y(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function p(l, e) {
    if (!(l instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  var x = "http://www.w3.org/2000/svg", s = (function() {
    function l(e, t, o) {
      p(this, l), this.svg = e, this.encodings = t, this.options = o, this.document = o.xmlDocument || document;
    }
    return d(l, [{
      key: "render",
      value: function() {
        var t = this.options.marginLeft;
        this.prepareSVG();
        for (var o = 0; o < this.encodings.length; o++) {
          var n = this.encodings[o], i = (0, v.default)(this.options, n.options), c = this.createGroup(t, i.marginTop, this.svg);
          this.setGroupOptions(c, i), this.drawSvgBarcode(c, i, n), this.drawSVGText(c, i, n), t += n.width;
        }
      }
    }, {
      key: "prepareSVG",
      value: function() {
        for (; this.svg.firstChild; )
          this.svg.removeChild(this.svg.firstChild);
        (0, h.calculateEncodingAttributes)(this.encodings, this.options);
        var t = (0, h.getTotalWidthOfEncodings)(this.encodings), o = (0, h.getMaximumHeightOfEncodings)(this.encodings), n = t + this.options.marginLeft + this.options.marginRight;
        this.setSvgAttributes(n, o), this.options.background && this.drawRect(0, 0, n, o, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
      }
    }, {
      key: "drawSvgBarcode",
      value: function(t, o, n) {
        var i = n.data, c;
        o.textPosition == "top" ? c = o.fontSize + o.textMargin : c = 0;
        for (var u = 0, _ = 0, S = 0; S < i.length; S++)
          _ = S * o.width + n.barcodePadding, i[S] === "1" ? u++ : u > 0 && (this.drawRect(_ - o.width * u, c, o.width * u, o.height, t), u = 0);
        u > 0 && this.drawRect(_ - o.width * (u - 1), c, o.width * u, o.height, t);
      }
    }, {
      key: "drawSVGText",
      value: function(t, o, n) {
        var i = this.document.createElementNS(x, "text");
        if (o.displayValue) {
          var c, u;
          i.setAttribute("style", "font:" + o.fontOptions + " " + o.fontSize + "px " + o.font), o.textPosition == "top" ? u = o.fontSize - o.textMargin : u = o.height + o.textMargin + o.fontSize, o.textAlign == "left" || n.barcodePadding > 0 ? (c = 0, i.setAttribute("text-anchor", "start")) : o.textAlign == "right" ? (c = n.width - 1, i.setAttribute("text-anchor", "end")) : (c = n.width / 2, i.setAttribute("text-anchor", "middle")), i.setAttribute("x", c), i.setAttribute("y", u), i.appendChild(this.document.createTextNode(n.text)), t.appendChild(i);
        }
      }
    }, {
      key: "setSvgAttributes",
      value: function(t, o) {
        var n = this.svg;
        n.setAttribute("width", t + "px"), n.setAttribute("height", o + "px"), n.setAttribute("x", "0px"), n.setAttribute("y", "0px"), n.setAttribute("viewBox", "0 0 " + t + " " + o), n.setAttribute("xmlns", x), n.setAttribute("version", "1.1"), n.setAttribute("style", "transform: translate(0,0)");
      }
    }, {
      key: "createGroup",
      value: function(t, o, n) {
        var i = this.document.createElementNS(x, "g");
        return i.setAttribute("transform", "translate(" + t + ", " + o + ")"), n.appendChild(i), i;
      }
    }, {
      key: "setGroupOptions",
      value: function(t, o) {
        t.setAttribute("style", "fill:" + o.lineColor + ";");
      }
    }, {
      key: "drawRect",
      value: function(t, o, n, i, c) {
        var u = this.document.createElementNS(x, "rect");
        return u.setAttribute("x", t), u.setAttribute("y", o), u.setAttribute("width", n), u.setAttribute("height", i), c.appendChild(u), u;
      }
    }]), l;
  })();
  return ht.default = s, ht;
}
var xt = {}, Rr;
function An() {
  if (Rr) return xt;
  Rr = 1, Object.defineProperty(xt, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function h(y, p) {
      for (var x = 0; x < p.length; x++) {
        var s = p[x];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(y, s.key, s);
      }
    }
    return function(y, p, x) {
      return p && h(y.prototype, p), x && h(y, x), y;
    };
  })();
  function f(h, y) {
    if (!(h instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  var v = (function() {
    function h(y, p, x) {
      f(this, h), this.object = y, this.encodings = p, this.options = x;
    }
    return d(h, [{
      key: "render",
      value: function() {
        this.object.encodings = this.encodings;
      }
    }]), h;
  })();
  return xt.default = v, xt;
}
var Er;
function kn() {
  if (Er) return dt;
  Er = 1, Object.defineProperty(dt, "__esModule", {
    value: !0
  });
  var d = Tn(), f = x(d), v = Dn(), h = x(v), y = An(), p = x(y);
  function x(s) {
    return s && s.__esModule ? s : { default: s };
  }
  return dt.default = { CanvasRenderer: f.default, SVGRenderer: h.default, ObjectRenderer: p.default }, dt;
}
var xe = {}, Or;
function Wr() {
  if (Or) return xe;
  Or = 1, Object.defineProperty(xe, "__esModule", {
    value: !0
  });
  function d(x, s) {
    if (!(x instanceof s))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(x, s) {
    if (!x)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return s && (typeof s == "object" || typeof s == "function") ? s : x;
  }
  function v(x, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof s);
    x.prototype = Object.create(s && s.prototype, { constructor: { value: x, enumerable: !1, writable: !0, configurable: !0 } }), s && (Object.setPrototypeOf ? Object.setPrototypeOf(x, s) : x.__proto__ = s);
  }
  var h = (function(x) {
    v(s, x);
    function s(l, e) {
      d(this, s);
      var t = f(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this));
      return t.name = "InvalidInputException", t.symbology = l, t.input = e, t.message = '"' + t.input + '" is not a valid input for ' + t.symbology, t;
    }
    return s;
  })(Error), y = (function(x) {
    v(s, x);
    function s() {
      d(this, s);
      var l = f(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this));
      return l.name = "InvalidElementException", l.message = "Not supported type to render on", l;
    }
    return s;
  })(Error), p = (function(x) {
    v(s, x);
    function s() {
      d(this, s);
      var l = f(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this));
      return l.name = "NoElementException", l.message = "No element to render on.", l;
    }
    return s;
  })(Error);
  return xe.InvalidInputException = h, xe.InvalidElementException = y, xe.NoElementException = p, xe;
}
var Tr;
function Cn() {
  if (Tr) return lt;
  Tr = 1, Object.defineProperty(lt, "__esModule", {
    value: !0
  });
  var d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f = On(), v = x(f), h = kn(), y = x(h), p = Wr();
  function x(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function s(t) {
    if (typeof t == "string")
      return l(t);
    if (Array.isArray(t)) {
      for (var o = [], n = 0; n < t.length; n++)
        o.push(s(t[n]));
      return o;
    } else {
      if (typeof HTMLCanvasElement < "u" && t instanceof HTMLImageElement)
        return e(t);
      if (t && t.nodeName && t.nodeName.toLowerCase() === "svg" || typeof SVGElement < "u" && t instanceof SVGElement)
        return {
          element: t,
          options: (0, v.default)(t),
          renderer: y.default.SVGRenderer
        };
      if (typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement)
        return {
          element: t,
          options: (0, v.default)(t),
          renderer: y.default.CanvasRenderer
        };
      if (t && t.getContext)
        return {
          element: t,
          renderer: y.default.CanvasRenderer
        };
      if (t && (typeof t > "u" ? "undefined" : d(t)) === "object" && !t.nodeName)
        return {
          element: t,
          renderer: y.default.ObjectRenderer
        };
      throw new p.InvalidElementException();
    }
  }
  function l(t) {
    var o = document.querySelectorAll(t);
    if (o.length !== 0) {
      for (var n = [], i = 0; i < o.length; i++)
        n.push(s(o[i]));
      return n;
    }
  }
  function e(t) {
    var o = document.createElement("canvas");
    return {
      element: o,
      options: (0, v.default)(t),
      renderer: y.default.CanvasRenderer,
      afterRender: function() {
        t.setAttribute("src", o.toDataURL());
      }
    };
  }
  return lt.default = s, lt;
}
var yt = {}, Dr;
function Pn() {
  if (Dr) return yt;
  Dr = 1, Object.defineProperty(yt, "__esModule", {
    value: !0
  });
  var d = /* @__PURE__ */ (function() {
    function h(y, p) {
      for (var x = 0; x < p.length; x++) {
        var s = p[x];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(y, s.key, s);
      }
    }
    return function(y, p, x) {
      return p && h(y.prototype, p), x && h(y, x), y;
    };
  })();
  function f(h, y) {
    if (!(h instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  var v = (function() {
    function h(y) {
      f(this, h), this.api = y;
    }
    return d(h, [{
      key: "handleCatch",
      value: function(p) {
        if (p.name === "InvalidInputException")
          if (this.api._options.valid !== this.api._defaults.valid)
            this.api._options.valid(!1);
          else
            throw p.message;
        else
          throw p;
        this.api.render = function() {
        };
      }
    }, {
      key: "wrapBarcodeCall",
      value: function(p) {
        try {
          var x = p.apply(void 0, arguments);
          return this.api._options.valid(!0), x;
        } catch (s) {
          return this.handleCatch(s), this.api;
        }
      }
    }]), h;
  })();
  return yt.default = v, yt;
}
var wt, Ar;
function In() {
  if (Ar) return wt;
  Ar = 1;
  var d = wn(), f = S(d), v = bt(), h = S(v), y = Rn(), p = S(y), x = En(), s = S(x), l = Cn(), e = S(l), t = zr(), o = S(t), n = Pn(), i = S(n), c = Wr(), u = qr(), _ = S(u);
  function S(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var R = function() {
  }, C = function(I, B, P) {
    var N = new R();
    if (typeof I > "u")
      throw Error("No element to render on was provided.");
    return N._renderProperties = (0, e.default)(I), N._encodings = [], N._options = _.default, N._errorHandler = new i.default(N), typeof B < "u" && (P = P || {}, P.format || (P.format = se()), N.options(P)[P.format](B, P).render()), N;
  };
  C.getModule = function(A) {
    return f.default[A];
  };
  for (var U in f.default)
    f.default.hasOwnProperty(U) && Q(f.default, U);
  function Q(A, I) {
    R.prototype[I] = R.prototype[I.toUpperCase()] = R.prototype[I.toLowerCase()] = function(B, P) {
      var N = this;
      return N._errorHandler.wrapBarcodeCall(function() {
        P.text = typeof P.text > "u" ? void 0 : "" + P.text;
        var q = (0, h.default)(N._options, P);
        q = (0, o.default)(q);
        var ke = A[I], Ce = ee(B, ke, q);
        return N._encodings.push(Ce), N;
      });
    };
  }
  function ee(A, I, B) {
    A = "" + A;
    var P = new I(A, B);
    if (!P.valid())
      throw new c.InvalidInputException(P.constructor.name, A);
    var N = P.encode();
    N = (0, p.default)(N);
    for (var q = 0; q < N.length; q++)
      N[q].options = (0, h.default)(B, N[q].options);
    return N;
  }
  function se() {
    return f.default.CODE128 ? "CODE128" : Object.keys(f.default)[0];
  }
  R.prototype.options = function(A) {
    return this._options = (0, h.default)(this._options, A), this;
  }, R.prototype.blank = function(A) {
    var I = new Array(A + 1).join("0");
    return this._encodings.push({ data: I }), this;
  }, R.prototype.init = function() {
    if (this._renderProperties) {
      Array.isArray(this._renderProperties) || (this._renderProperties = [this._renderProperties]);
      var A;
      for (var I in this._renderProperties) {
        A = this._renderProperties[I];
        var B = (0, h.default)(this._options, A.options);
        B.format == "auto" && (B.format = se()), this._errorHandler.wrapBarcodeCall(function() {
          var P = B.value, N = f.default[B.format.toUpperCase()], q = ee(P, N, B);
          oe(A, q, B);
        });
      }
    }
  }, R.prototype.render = function() {
    if (!this._renderProperties)
      throw new c.NoElementException();
    if (Array.isArray(this._renderProperties))
      for (var A = 0; A < this._renderProperties.length; A++)
        oe(this._renderProperties[A], this._encodings, this._options);
    else
      oe(this._renderProperties, this._encodings, this._options);
    return this;
  }, R.prototype._defaults = _.default;
  function oe(A, I, B) {
    I = (0, p.default)(I);
    for (var P = 0; P < I.length; P++)
      I[P].options = (0, h.default)(B, I[P].options), (0, s.default)(I[P].options);
    (0, s.default)(B);
    var N = A.renderer, q = new N(A.element, I, B);
    q.render(), A.afterRender && A.afterRender();
  }
  return typeof window < "u" && (window.JsBarcode = C), typeof jQuery < "u" && (jQuery.fn.JsBarcode = function(A, I) {
    var B = [];
    return jQuery(this).each(function() {
      B.push(this);
    }), C(B, A, I);
  }), wt = C, wt;
}
var Bn = In();
const Vr = /* @__PURE__ */ Gr(Bn), ye = "data:image/png;base64,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", T = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 12,
    fontFamily: "Courier",
    fontSize: 10,
    // Ultra-dark settings
    color: "#000000",
    fontWeight: "bold",
    // Print optimization
    printColorAdjust: "exact",
    WebkitPrintColorAdjust: "exact",
    // Advanced text enhancement for maximum darkness
    textShadow: "0.8px 0.8px 0px #000000",
    letterSpacing: "0.2px",
    // Text stroke for extra boldness
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000",
    // Additional strength techniques
    textRendering: "optimizeLegibility",
    fontSmoothing: "antialiased",
    WebkitFontSmoothing: "antialiased"
  },
  container: {
    width: "100%",
    padding: 0
  },
  header: {
    textAlign: "center",
    marginBottom: 8,
    paddingBottom: 8
  },
  logo: {
    fontSize: 22,
    // Even larger
    fontWeight: "bold",
    marginBottom: 4,
    color: "#000000",
    textShadow: "1.5px 1.5px 0px #000000",
    letterSpacing: "0.3px",
    textStroke: "0.3px #000000",
    WebkitTextStroke: "0.3px #000000"
  },
  logoImage: {
    width: 60,
    height: 40,
    alignSelf: "center"
  },
  companyName: {
    fontSize: 15,
    // Even larger
    marginBottom: 4,
    fontWeight: "bold",
    color: "#000000",
    textShadow: "1px 1px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  address: {
    fontSize: 10,
    // Larger
    color: "#000000",
    marginBottom: 2,
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  phone: {
    fontSize: 10,
    // Larger
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  metaInfo: {
    fontSize: 10,
    // Larger
    marginBottom: 8,
    paddingBottom: 8
  },
  metaRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2
  },
  metaLabel: {
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  metaValue: {
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  table: {
    width: "100%",
    marginBottom: 10
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "4px solid #000000"
    // Extra thick border
  },
  tableHeaderCell: {
    fontSize: 10,
    // Larger
    fontWeight: "bold",
    color: "#000000",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  colDescription: {
    width: "49%"
  },
  colPrice: {
    width: "16%",
    // fits a 5-digit price at 10pt Courier
    textAlign: "right"
  },
  colQty: {
    width: "11%",
    // keeps a gap between the Price and QTY headers
    textAlign: "right"
  },
  colAmount: {
    width: "24%",
    textAlign: "right"
  },
  tableRow: {
    flexDirection: "row",
    marginBottom: 4
  },
  tableCell: {
    fontSize: 10,
    // Larger
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  itemDescription: {
    fontSize: 9.5,
    // Larger
    lineHeight: 1.3,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  discountRow: {
    fontSize: 9,
    // Larger
    paddingTop: 0,
    marginBottom: 4,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  totalsSection: {
    borderTop: "4px solid #000000",
    // Extra thick border
    paddingTop: 8
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 10,
    // Larger
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  netAmount: {
    fontWeight: "bold",
    fontSize: 12,
    // Larger
    marginTop: 4,
    color: "#000000",
    textShadow: "1px 1px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  // divider: {
  //   borderTop: '4px solid #000000', // Extra thick border
  //   marginVertical: 8,
  // },
  footer: {
    marginTop: 12,
    borderTop: "4px solid #000000",
    // Extra thick border
    paddingTop: 10,
    fontSize: 9,
    // Larger
    color: "#000000",
    textAlign: "center",
    fontWeight: "bold"
  },
  validText: {
    marginBottom: 8,
    fontWeight: "bold",
    color: "#000000",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  termsList: {
    textAlign: "left",
    marginBottom: 10,
    paddingLeft: 4
  },
  termsItem: {
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold",
    letterSpacing: "0.2px",
    textStroke: "5px #000000",
    WebkitTextStroke: "5px #000000",
    fontSize: 9
    // Larger for terms
  },
  developerInfo: {
    fontSize: 8.5,
    // Larger
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  barcode: {
    width: 150,
    // Wider for better scanning
    height: 40,
    // Adequate height for scanning
    marginTop: 2,
    marginBottom: 2,
    alignSelf: "center"
  },
  divider: {
    height: 1,
    backgroundColor: "#000000",
    width: "100%",
    marginVertical: 4
  },
  itemDivider: {
    height: 1,
    backgroundColor: "#000000",
    width: "100%",
    marginVertical: 3,
    opacity: 0.5
  },
  dottedDivider: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 3,
    height: 1
  },
  dot: {
    width: 2,
    height: 2,
    backgroundColor: "#000000",
    marginHorizontal: 2,
    borderRadius: 1
  }
}), Nn = (d) => {
  try {
    const f = document.createElement("canvas"), v = f.getContext("2d"), h = 6;
    return f.width = 300 * h, f.height = 100 * h, v.scale(h, h), Vr(f, d, {
      format: "CODE128",
      // Best for alphanumeric data like invoice numbers
      width: 2,
      // Slightly thicker for high DPI
      height: 60,
      // Taller for better scanning
      displayValue: !1,
      // Hide text below barcode to save space
      margin: 10,
      // More margin for better scanning
      background: "#FFFFFF",
      lineColor: "#000000",
      // Optimize for scanning speed
      fontSize: 0,
      // No text display
      textAlign: "center",
      textPosition: "bottom",
      textMargin: 0,
      // Ensure high contrast and clean lines
      valid: function(y) {
        return y;
      }
    }), f.toDataURL("image/png", 1);
  } catch (f) {
    return console.error("Error generating barcode:", f), null;
  }
}, Mn = {
  company: {
    logo: "A",
    name: "Accoutre Clothing",
    address: "332-Z, Phase 3, DHA, Lahore",
    phone: "+92-335-5765923"
  },
  transaction: {
    date: "23-Sep-25",
    time: "12:32:37 am",
    salesman: "Admin",
    invoiceNumber: "250923003237"
  },
  Sale: {
    SaleNo: "250923003237"
  },
  items: [
    {
      description: "LUMBERJACK OUTDOORS Big Strap Slide - EU 40",
      price: 3550,
      quantity: 1,
      amount: 2850,
      discount: 700
    },
    {
      description: "LUMBERJACK OUTDOORS Big Strap Slide - EU 40",
      price: 3550,
      quantity: 1,
      amount: 2850,
      discount: 700
    }
  ],
  totals: {
    subTotal: 3550,
    additionalDiscount: 0,
    totalDiscount: 900,
    netAmount: 2650,
    cashAmount: 2650,
    bankAmount: 0,
    cashReturn: 0
  },
  terms: [
    "All Prices Are Fixed",
    "Please retain original receipt for exchange and refund within 14 days of purchase.",
    "For exchange and refund all items must be in original condition with all tabs and label intact.",
    "Articles worn/washed/shrunk will not be exchanged and refunded.",
    "Please read and follow washing instructions on the care label carefully."
  ],
  developer: {
    name: "Esper Solutions",
    website: "www.esper.solutions"
  }
}, Kn = ({
  receiptData: d = Mn,
  validDays: f = 14,
  printQuality: v = "ultra-dark",
  // Accept printQuality prop for backward compatibility
  logoSrc: h,
  companyName: y,
  companyAddress: p,
  companyPhone: x
}) => {
  const { company: s, transaction: l, items: e, totals: t, terms: o, developer: n, Sale: i } = d, c = {
    ...s,
    name: y || s.name,
    address: p || s.address,
    phone: x || s.phone
  }, u = i?.SaleNo ? Nn(i.SaleNo) : null, _ = h || ye;
  return /* @__PURE__ */ r.jsx(ce, { dpi: 600, children: /* @__PURE__ */ r.jsx(
    ue,
    {
      size: [226.77, 841.89],
      style: T.page,
      dpi: 700,
      children: /* @__PURE__ */ r.jsxs(m, { style: T.container, children: [
        /* @__PURE__ */ r.jsxs(m, { style: T.header, children: [
          /* @__PURE__ */ r.jsx(ne, { src: _, style: T.logoImage }),
          /* @__PURE__ */ r.jsx(a, { style: T.companyName, children: c.name }),
          /* @__PURE__ */ r.jsx(a, { style: T.address, children: c.address }),
          /* @__PURE__ */ r.jsx(a, { style: T.phone, children: c.phone })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: T.divider }),
        /* @__PURE__ */ r.jsxs(m, { style: T.metaInfo, children: [
          /* @__PURE__ */ r.jsxs(m, { style: T.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: T.metaLabel, children: "Date:" }),
            /* @__PURE__ */ r.jsx(a, { style: T.metaValue, children: l.date })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: T.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: T.metaLabel, children: "Time:" }),
            /* @__PURE__ */ r.jsx(a, { style: T.metaValue, children: l.time })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: T.metaRow, children: [
            /* @__PURE__ */ r.jsxs(m, { style: { ...T.metaRow, marginBottom: 0 }, children: [
              /* @__PURE__ */ r.jsx(a, { style: T.metaLabel, children: "Salesman:" }),
              /* @__PURE__ */ r.jsx(a, { style: T.metaValue, children: l.salesman })
            ] }),
            /* @__PURE__ */ r.jsx(a, { style: T.metaValue, children: l.invoiceNumber })
          ] })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: T.divider }),
        u && /* @__PURE__ */ r.jsx(m, { style: { alignItems: "center", marginBottom: 10 }, children: /* @__PURE__ */ r.jsx(ne, { src: u, style: T.barcode }) }),
        u && /* @__PURE__ */ r.jsx(m, { style: T.divider }),
        /* @__PURE__ */ r.jsxs(m, { style: T.table, children: [
          /* @__PURE__ */ r.jsxs(m, { style: T.tableHeader, children: [
            /* @__PURE__ */ r.jsx(a, { style: [T.tableHeaderCell, T.colDescription], children: "Description" }),
            /* @__PURE__ */ r.jsx(a, { style: [T.tableHeaderCell, T.colPrice], children: "Price" }),
            /* @__PURE__ */ r.jsx(a, { style: [T.tableHeaderCell, T.colQty], children: "QTY" }),
            /* @__PURE__ */ r.jsx(a, { style: [T.tableHeaderCell, T.colAmount], children: "Amount" })
          ] }),
          /* @__PURE__ */ r.jsx(m, { style: { ...T.divider } }),
          e.map((S, R) => /* @__PURE__ */ r.jsxs(m, { wrap: !1, children: [
            /* @__PURE__ */ r.jsxs(m, { style: T.tableRow, children: [
              /* @__PURE__ */ r.jsx(m, { style: T.colDescription, children: /* @__PURE__ */ r.jsx(a, { style: [T.tableCell, T.itemDescription], children: S.description }) }),
              /* @__PURE__ */ r.jsx(a, { style: [T.tableCell, T.colPrice], children: S.price }),
              /* @__PURE__ */ r.jsx(a, { style: [T.tableCell, T.colQty], children: S.quantity }),
              /* @__PURE__ */ r.jsx(a, { style: [T.tableCell, T.colAmount], children: S.amount })
            ] }),
            S.discount > 0 && /* @__PURE__ */ r.jsxs(a, { style: T.discountRow, children: [
              "(Item Discount: ",
              S.discount,
              ")"
            ] }),
            R < e.length - 1 && /* @__PURE__ */ r.jsx(m, { style: T.dottedDivider, children: Array.from({ length: 35 }, (C, U) => /* @__PURE__ */ r.jsx(m, { style: T.dot }, U)) })
          ] }, R))
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: T.totalsSection, wrap: !1, children: [
          /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Sub Total:" }),
            /* @__PURE__ */ r.jsx(a, { children: t.subTotal })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Product Discount:" }),
            /* @__PURE__ */ r.jsxs(a, { children: [
              "-",
              t.totalDiscount
            ] })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Additional Discount:" }),
            /* @__PURE__ */ r.jsxs(a, { children: [
              "-",
              t.additionalDiscount
            ] })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: [T.totalRow, T.netAmount], children: [
            /* @__PURE__ */ r.jsx(a, { children: "Net Amount:" }),
            /* @__PURE__ */ r.jsx(a, { children: t.netAmount })
          ] }),
          /* @__PURE__ */ r.jsx(m, { style: T.divider }),
          t.cashAmount > 0 && /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Cash received:" }),
            /* @__PURE__ */ r.jsx(a, { children: t.cashAmount })
          ] }),
          t.bankAmount > 0 && /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Bank received:" }),
            /* @__PURE__ */ r.jsx(a, { children: t.bankAmount })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: T.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Cash Return:" }),
            /* @__PURE__ */ r.jsx(a, { children: t.cashReturn })
          ] })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: T.footer, wrap: !1, children: [
          /* @__PURE__ */ r.jsxs(a, { style: T.validText, children: [
            "* Valid for ",
            f,
            " days only"
          ] }),
          /* @__PURE__ */ r.jsx(m, { style: T.termsList, children: o.map((S, R) => /* @__PURE__ */ r.jsxs(a, { style: T.termsItem, children: [
            R + 1,
            ". ",
            S
          ] }, R)) }),
          /* @__PURE__ */ r.jsx(a, { style: { marginBottom: 8, color: "#000000", fontWeight: "bold", textShadow: "0.5px 0.5px 0px #000000", letterSpacing: "0.2px", textStroke: "0.2px #000000", WebkitTextStroke: "0.2px #000000" }, children: "* Terms and conditions apply." }),
          /* @__PURE__ */ r.jsxs(m, { style: T.developerInfo, children: [
            /* @__PURE__ */ r.jsxs(a, { children: [
              "Developed by ",
              n.name
            ] }),
            /* @__PURE__ */ r.jsx(a, { children: n.website })
          ] })
        ] })
      ] })
    }
  ) });
}, D = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 12,
    fontFamily: "Courier",
    fontSize: 9,
    width: 226.77,
    height: 595.28,
    // Maximum print quality settings
    color: "#000000",
    fontWeight: "bold",
    // Print optimization for strongest ink density
    printColorAdjust: "exact",
    WebkitPrintColorAdjust: "exact",
    // Force black text rendering
    textRendering: "optimizeLegibility",
    fontSmoothing: "antialiased",
    WebkitFontSmoothing: "antialiased"
  },
  container: {
    width: "100%",
    padding: 0
  },
  header: {
    textAlign: "center",
    marginBottom: 12,
    borderBottom: "3px solid #000000",
    // Extra thick border
    paddingBottom: 10
  },
  logo: {
    fontSize: 20,
    // Larger for better visibility
    fontWeight: "bold",
    marginBottom: 4,
    color: "#000000"
  },
  companyName: {
    fontSize: 13,
    // Larger for better visibility
    marginBottom: 4,
    fontWeight: "bold",
    color: "#000000"
  },
  address: {
    fontSize: 9,
    // Larger for better visibility
    color: "#000000",
    marginBottom: 2,
    fontWeight: "bold"
  },
  phone: {
    fontSize: 9,
    // Larger for better visibility
    color: "#000000",
    fontWeight: "bold"
  },
  metaInfo: {
    fontSize: 9,
    // Larger for better visibility
    marginBottom: 10,
    borderBottom: "3px solid #000000",
    // Extra thick border
    paddingBottom: 10
  },
  metaRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3
  },
  metaLabel: {
    color: "#000000",
    fontWeight: "bold"
  },
  metaValue: {
    color: "#000000",
    fontWeight: "bold"
  },
  table: {
    width: "100%",
    marginBottom: 10
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "3px solid #000000",
    // Extra thick border
    paddingBottom: 5,
    marginBottom: 5
  },
  tableHeaderCell: {
    fontSize: 9,
    // Larger for better visibility
    fontWeight: "bold",
    color: "#000000"
  },
  colDescription: {
    width: "50%"
  },
  colPrice: {
    width: "15%",
    textAlign: "right"
  },
  colQty: {
    width: "10%",
    textAlign: "right"
  },
  colAmount: {
    width: "25%",
    textAlign: "right"
  },
  tableRow: {
    flexDirection: "row",
    marginBottom: 4
  },
  tableCell: {
    fontSize: 9,
    // Larger for better visibility
    color: "#000000",
    fontWeight: "bold"
  },
  itemDescription: {
    fontSize: 8.5,
    // Larger for better visibility
    lineHeight: 1.3,
    color: "#000000",
    fontWeight: "bold"
  },
  discountRow: {
    fontSize: 8,
    // Larger for better visibility
    paddingTop: 0,
    marginBottom: 4,
    color: "#000000",
    fontWeight: "bold"
  },
  totalsSection: {
    borderTop: "3px solid #000000",
    // Extra thick border
    paddingTop: 8
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 9,
    // Larger for better visibility
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold"
  },
  netAmount: {
    fontWeight: "bold",
    fontSize: 10,
    // Larger for better visibility
    marginTop: 4,
    color: "#000000"
  },
  divider: {
    borderTop: "3px solid #000000",
    // Extra thick border
    marginVertical: 8
  },
  footer: {
    marginTop: 12,
    borderTop: "3px solid #000000",
    // Extra thick border
    paddingTop: 10,
    fontSize: 8,
    // Larger for better visibility
    color: "#000000",
    textAlign: "center",
    fontWeight: "bold"
  },
  validText: {
    marginBottom: 8,
    fontWeight: "bold",
    color: "#000000"
  },
  termsList: {
    textAlign: "left",
    marginBottom: 10,
    paddingLeft: 4
  },
  termsItem: {
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold"
    // Changed to bold for maximum visibility
  },
  developerInfo: {
    fontSize: 7.5,
    // Larger for better visibility
    color: "#000000",
    fontWeight: "bold"
  }
}), Fn = {
  company: {
    logo: "A",
    name: "Accoutre Clothing",
    address: "332-Z, Phase 3, DHA, Lahore",
    phone: "+92-335-5765923"
  },
  transaction: {
    date: "23-Sep-25",
    time: "12:32:37 am",
    salesman: "Admin",
    invoiceNumber: "250923003237"
  },
  items: [
    {
      description: "LUMBERJACK OUTDOORS Big Strap Slide - EU 40",
      price: 3550,
      quantity: 1,
      amount: 2850,
      discount: 700
    }
  ],
  totals: {
    subTotal: 3550,
    totalDiscount: 900,
    netAmount: 2650,
    amountTendered: 0,
    cashReturn: -2650,
    totalItems: 1
  },
  terms: [
    "All Prices Are Fixed",
    "Please retain original receipt for exchange and refund within 14 days of purchase.",
    "For exchange and refund all items must be in original condition with all tabs and label intact.",
    "Articles worn/washed/shrunk will not be exchanged and refunded.",
    "Please read and follow washing instructions on the care label carefully."
  ],
  developer: {
    name: "Esper Solutions",
    website: "www.esper.solutions",
    phone: "0336-9040248"
  }
}, Yn = ({
  receiptData: d = Fn,
  validDays: f = 14
}) => {
  const { company: v, transaction: h, items: y, totals: p, terms: x, developer: s } = d;
  return /* @__PURE__ */ r.jsx(ce, { children: /* @__PURE__ */ r.jsx(
    ue,
    {
      size: [226.77, 595.28],
      style: D.page,
      wrap: !1,
      dpi: 300,
      compress: !1,
      printColorAdjust: "exact",
      WebkitPrintColorAdjust: "exact",
      children: /* @__PURE__ */ r.jsxs(m, { style: D.container, children: [
        /* @__PURE__ */ r.jsxs(m, { style: D.header, children: [
          /* @__PURE__ */ r.jsx(a, { style: D.logo, children: v.logo }),
          /* @__PURE__ */ r.jsx(a, { style: D.companyName, children: v.name }),
          /* @__PURE__ */ r.jsx(a, { style: D.address, children: v.address }),
          /* @__PURE__ */ r.jsx(a, { style: D.phone, children: v.phone })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: D.metaInfo, children: [
          /* @__PURE__ */ r.jsxs(m, { style: D.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: D.metaLabel, children: "Date:" }),
            /* @__PURE__ */ r.jsx(a, { style: D.metaValue, children: h.date })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: D.metaLabel, children: "Time:" }),
            /* @__PURE__ */ r.jsx(a, { style: D.metaValue, children: h.time })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: D.metaLabel, children: "Salesman:" }),
            /* @__PURE__ */ r.jsx(a, { style: D.metaValue, children: h.salesman })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.metaRow, children: [
            /* @__PURE__ */ r.jsx(a, { style: D.metaLabel, children: "Invoice#:" }),
            /* @__PURE__ */ r.jsx(a, { style: D.metaValue, children: h.invoiceNumber })
          ] })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: D.table, children: [
          /* @__PURE__ */ r.jsxs(m, { style: D.tableHeader, children: [
            /* @__PURE__ */ r.jsx(a, { style: [D.tableHeaderCell, D.colDescription], children: "Description" }),
            /* @__PURE__ */ r.jsx(a, { style: [D.tableHeaderCell, D.colPrice], children: "Price" }),
            /* @__PURE__ */ r.jsx(a, { style: [D.tableHeaderCell, D.colQty], children: "QTY" }),
            /* @__PURE__ */ r.jsx(a, { style: [D.tableHeaderCell, D.colAmount], children: "Amount" })
          ] }),
          y.map((l, e) => /* @__PURE__ */ r.jsxs(Br.Fragment, { children: [
            /* @__PURE__ */ r.jsxs(m, { style: D.tableRow, children: [
              /* @__PURE__ */ r.jsx(m, { style: D.colDescription, children: /* @__PURE__ */ r.jsx(a, { style: [D.tableCell, D.itemDescription], children: l.description }) }),
              /* @__PURE__ */ r.jsx(a, { style: [D.tableCell, D.colPrice], children: l.price }),
              /* @__PURE__ */ r.jsx(a, { style: [D.tableCell, D.colQty], children: l.quantity }),
              /* @__PURE__ */ r.jsx(a, { style: [D.tableCell, D.colAmount], children: l.amount })
            ] }),
            l.discount > 0 && /* @__PURE__ */ r.jsxs(a, { style: D.discountRow, children: [
              "(Item Discount: ",
              l.discount,
              ")"
            ] })
          ] }, e))
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: D.totalsSection, children: [
          /* @__PURE__ */ r.jsxs(m, { style: D.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Sub Total:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.subTotal })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Total Discount:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.totalDiscount })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: [D.totalRow, D.netAmount], children: [
            /* @__PURE__ */ r.jsx(a, { children: "Net Amount:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.netAmount })
          ] }),
          /* @__PURE__ */ r.jsx(m, { style: D.divider }),
          /* @__PURE__ */ r.jsxs(m, { style: D.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Amount Tendered:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.amountTendered })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Cash Return:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.cashReturn })
          ] }),
          /* @__PURE__ */ r.jsxs(m, { style: D.totalRow, children: [
            /* @__PURE__ */ r.jsx(a, { children: "Total Items:" }),
            /* @__PURE__ */ r.jsx(a, { children: p.totalItems })
          ] })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: D.footer, children: [
          /* @__PURE__ */ r.jsxs(a, { style: D.validText, children: [
            "* Valid for ",
            f,
            " days only"
          ] }),
          /* @__PURE__ */ r.jsx(m, { style: D.termsList, children: x.map((l, e) => /* @__PURE__ */ r.jsxs(a, { style: D.termsItem, children: [
            e + 1,
            ". ",
            l
          ] }, e)) }),
          /* @__PURE__ */ r.jsx(a, { style: { marginBottom: 8, color: "#000000", fontWeight: "bold" }, children: "* Terms and conditions apply." }),
          /* @__PURE__ */ r.jsxs(m, { style: D.developerInfo, children: [
            /* @__PURE__ */ r.jsxs(a, { children: [
              "Developed by ",
              s.name
            ] }),
            /* @__PURE__ */ r.jsxs(a, { children: [
              s.website,
              " | ",
              s.phone
            ] })
          ] })
        ] })
      ] })
    }
  ) });
}, E = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 12,
    fontFamily: "Courier",
    fontSize: 10,
    color: "#000000",
    fontWeight: "bold",
    printColorAdjust: "exact",
    WebkitPrintColorAdjust: "exact",
    textShadow: "0.8px 0.8px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000",
    textRendering: "optimizeLegibility",
    fontSmoothing: "antialiased",
    WebkitFontSmoothing: "antialiased"
  },
  container: { width: "100%", padding: 0 },
  header: { textAlign: "center", marginBottom: 8, paddingBottom: 8 },
  logoImage: { width: 60, height: 40, alignSelf: "center" },
  companyName: {
    fontSize: 15,
    marginBottom: 4,
    fontWeight: "bold",
    color: "#000000",
    textShadow: "1px 1px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  address: {
    fontSize: 10,
    color: "#000000",
    marginBottom: 2,
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  phone: {
    fontSize: 10,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  divider: { height: 1, backgroundColor: "#000000", width: "100%", marginVertical: 4 },
  metaInfo: { fontSize: 10, marginBottom: 8, paddingBottom: 8 },
  metaRow: { flexDirection: "row", justifyContent: "space-between", marginBottom: 2 },
  metaLabel: {
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  metaValue: {
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  sectionTitle: {
    marginTop: 6,
    marginBottom: 4,
    fontSize: 11,
    textAlign: "center",
    fontWeight: "bold"
  },
  table: { width: "100%", marginBottom: 8 },
  tableHeader: { flexDirection: "row", borderBottom: "4px solid #000000" },
  tableHeaderCell: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#000000",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  colDescription: { width: "49%" },
  colPrice: { width: "16%", textAlign: "right" },
  // fits a 5-digit price at 10pt Courier
  colQty: { width: "11%", textAlign: "right" },
  // keeps a gap between the Price and QTY headers
  colAmount: { width: "24%", textAlign: "right" },
  tableRow: { flexDirection: "row", marginBottom: 4 },
  tableCell: {
    fontSize: 10,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  itemDescription: {
    fontSize: 9.5,
    lineHeight: 1.3,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  discountRow: {
    fontSize: 9,
    paddingTop: 0,
    marginBottom: 4,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  dottedDivider: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 3,
    height: 1
  },
  dot: { width: 2, height: 2, backgroundColor: "#000000", marginHorizontal: 2, borderRadius: 1 },
  totalsSection: { borderTop: "4px solid #000000", paddingTop: 8 },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 10,
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  netAmount: {
    fontWeight: "bold",
    fontSize: 12,
    marginTop: 4,
    color: "#000000",
    textShadow: "1px 1px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  barcode: { width: 150, height: 40, marginTop: 2, marginBottom: 2, alignSelf: "center" },
  footer: {
    marginTop: 12,
    borderTop: "4px solid #000000",
    paddingTop: 10,
    fontSize: 9,
    color: "#000000",
    textAlign: "center",
    fontWeight: "bold"
  },
  validText: {
    marginBottom: 8,
    fontWeight: "bold",
    color: "#000000",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  },
  termsList: { textAlign: "left", marginBottom: 10, paddingLeft: 4 },
  termsItem: {
    marginBottom: 3,
    color: "#000000",
    fontWeight: "bold",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000",
    fontSize: 9
  },
  developerInfo: {
    fontSize: 8.5,
    color: "#000000",
    fontWeight: "bold",
    textShadow: "0.5px 0.5px 0px #000000",
    letterSpacing: "0.2px",
    textStroke: "0.2px #000000",
    WebkitTextStroke: "0.2px #000000"
  }
}), Ln = (d) => {
  try {
    const f = document.createElement("canvas"), v = f.getContext("2d"), h = 6;
    return f.width = 300 * h, f.height = 100 * h, v.scale(h, h), Vr(f, d, {
      format: "CODE128",
      width: 2,
      height: 60,
      displayValue: !1,
      margin: 10,
      background: "#FFFFFF",
      lineColor: "#000000",
      fontSize: 0,
      textAlign: "center",
      textPosition: "bottom",
      textMargin: 0,
      valid: function(y) {
        return y;
      }
    }), f.toDataURL("image/png", 1);
  } catch (f) {
    return console.error("Error generating barcode:", f), null;
  }
}, zn = {
  ExchangeDate: "2025-09-30T12:30:00",
  ExchangeNo: "EX-20250930-173030",
  TotalReturnValue: "0.00",
  TotalGivenValue: "0.00",
  ExchangeDifference: "0.00",
  CashReceived: "0.00",
  CashReturned: "0.00",
  BankReceived: "0.00",
  BankReturned: "0.00",
  ReturnedItemsDiscountPercentage: "0.00",
  GivenItemsDiscountPercentage: "0.00",
  ReturnedItemsDiscountAmount: "0.00",
  GivenItemsDiscountAmount: "0.00",
  details: []
}, qn = [
  "All Prices Are Fixed",
  "Please retain original receipt for exchange and refund within 14 days of purchase.",
  "For exchange and refund all items must be in original condition with all tabs and label intact.",
  "Articles worn/washed/shrunk will not be exchanged and refunded.",
  "Please read and follow washing instructions on the care label carefully."
], Hn = {
  name: "Esper Solutions",
  website: "www.esper.solutions"
}, Wn = (d) => {
  try {
    const f = new Date(d), v = f.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" }), h = f.toLocaleTimeString("en-GB");
    return { date: v, time: h };
  } catch {
    return { date: "", time: "" };
  }
}, M = (d) => {
  if (d == null) return 0;
  const f = typeof d == "number" ? d : parseFloat(String(d));
  return isNaN(f) ? 0 : f;
}, Jn = ({
  data: d = zn,
  logoSrc: f,
  validDays: v = 14,
  terms: h = qn,
  developer: y = Hn,
  companyName: p,
  companyAddress: x,
  companyPhone: s
}) => {
  const l = {
    name: p || "Fables By Accoutre Clothing",
    address: x || "Climate Plaza , Street 36 , G13/2",
    phone: s || "+92 303 0941111"
  }, { date: e, time: t } = Wn(d.ExchangeDate), o = f || ye, n = d.ExchangeNo ? Ln(d.ExchangeNo) : null, i = (d.details || []).filter((_) => _.ExchangeType === "RETURNED"), c = (d.details || []).filter((_) => _.ExchangeType === "GIVEN"), u = (_, S, R) => {
    const C = _?.item?.Name || "", U = M(_.Price), Q = M(_.Quantity), ee = M(_.Discount), se = U * Q - ee;
    return /* @__PURE__ */ r.jsxs(m, { wrap: !1, children: [
      /* @__PURE__ */ r.jsxs(m, { style: E.tableRow, children: [
        /* @__PURE__ */ r.jsx(m, { style: E.colDescription, children: /* @__PURE__ */ r.jsx(a, { style: [E.tableCell, E.itemDescription], children: C }) }),
        /* @__PURE__ */ r.jsx(a, { style: [E.tableCell, E.colPrice], children: U.toFixed(0) }),
        /* @__PURE__ */ r.jsx(a, { style: [E.tableCell, E.colQty], children: Q }),
        /* @__PURE__ */ r.jsx(a, { style: [E.tableCell, E.colAmount], children: se.toFixed(0) })
      ] }),
      ee > 0 && /* @__PURE__ */ r.jsxs(a, { style: E.discountRow, children: [
        "(Item Discount: ",
        ee.toFixed(0),
        ")"
      ] }),
      !R && /* @__PURE__ */ r.jsx(m, { style: E.dottedDivider, children: Array.from({ length: 35 }, (oe, A) => /* @__PURE__ */ r.jsx(m, { style: E.dot }, A)) })
    ] }, S);
  };
  return /* @__PURE__ */ r.jsx(ce, { dpi: 600, children: /* @__PURE__ */ r.jsxs(ue, { size: [226.77, 841.89], style: E.page, dpi: 700, children: [
    /* @__PURE__ */ r.jsxs(m, { style: E.container, children: [
      /* @__PURE__ */ r.jsxs(m, { style: E.header, children: [
        /* @__PURE__ */ r.jsx(ne, { src: o, style: E.logoImage }),
        /* @__PURE__ */ r.jsx(a, { style: E.companyName, children: l.name }),
        /* @__PURE__ */ r.jsx(a, { style: E.address, children: l.address }),
        /* @__PURE__ */ r.jsx(a, { style: E.phone, children: l.phone })
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: E.divider }),
      /* @__PURE__ */ r.jsxs(m, { style: E.metaInfo, children: [
        /* @__PURE__ */ r.jsxs(m, { style: E.metaRow, children: [
          /* @__PURE__ */ r.jsx(a, { style: E.metaLabel, children: "Date:" }),
          /* @__PURE__ */ r.jsx(a, { style: E.metaValue, children: e })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: E.metaRow, children: [
          /* @__PURE__ */ r.jsx(a, { style: E.metaLabel, children: "Time:" }),
          /* @__PURE__ */ r.jsx(a, { style: E.metaValue, children: t })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: E.metaRow, children: [
          /* @__PURE__ */ r.jsx(a, { style: E.metaLabel, children: "Exchange#:" }),
          /* @__PURE__ */ r.jsx(a, { style: E.metaValue, children: d.ExchangeNo })
        ] })
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: E.divider }),
      n && /* @__PURE__ */ r.jsx(m, { style: { alignItems: "center", marginBottom: 10 }, children: /* @__PURE__ */ r.jsx(ne, { src: n, style: E.barcode }) }),
      n && /* @__PURE__ */ r.jsx(m, { style: E.divider }),
      i.length > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.table, children: [
        /* @__PURE__ */ r.jsx(a, { style: E.sectionTitle, minPresenceAhead: 60, children: "Returned Items" }),
        /* @__PURE__ */ r.jsxs(m, { style: E.tableHeader, children: [
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colDescription], children: "Description" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colPrice], children: "Price" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colQty], children: "QTY" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colAmount], children: "Amount" })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: { height: 1, backgroundColor: "#000000", width: "100%", marginVertical: 4 } }),
        i.map((_, S) => u(_, S, S === i.length - 1))
      ] }),
      c.length > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.table, children: [
        /* @__PURE__ */ r.jsx(a, { style: E.sectionTitle, minPresenceAhead: 60, children: "Sold Items" }),
        /* @__PURE__ */ r.jsxs(m, { style: E.tableHeader, children: [
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colDescription], children: "Description" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colPrice], children: "Price" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colQty], children: "QTY" }),
          /* @__PURE__ */ r.jsx(a, { style: [E.tableHeaderCell, E.colAmount], children: "Amount" })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: { height: 1, backgroundColor: "#000000", width: "100%", marginVertical: 4 } }),
        c.map((_, S) => u(_, S, S === c.length - 1))
      ] }),
      /* @__PURE__ */ r.jsxs(m, { style: E.totalsSection, wrap: !1, children: [
        /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Returned Value:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.TotalReturnValue).toFixed(0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Sold Value:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.TotalGivenValue).toFixed(0) })
        ] }),
        M(d.ReturnedItemsDiscountPercentage) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsxs(a, { children: [
            "Returned Discount (",
            M(d.ReturnedItemsDiscountPercentage).toFixed(1),
            "%):"
          ] }),
          /* @__PURE__ */ r.jsxs(a, { children: [
            "-",
            M(d.ReturnedItemsDiscountAmount).toFixed(0)
          ] })
        ] }),
        M(d.GivenItemsDiscountPercentage) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsxs(a, { children: [
            "Sale Discount (",
            M(d.GivenItemsDiscountPercentage).toFixed(1),
            "%):"
          ] }),
          /* @__PURE__ */ r.jsxs(a, { children: [
            "-",
            M(d.GivenItemsDiscountAmount).toFixed(0)
          ] })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: E.divider }),
        /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Net Returned:" }),
          /* @__PURE__ */ r.jsx(a, { children: (M(d.TotalReturnValue) - M(d.ReturnedItemsDiscountAmount)).toFixed(0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Net Sale:" }),
          /* @__PURE__ */ r.jsx(a, { children: (M(d.TotalGivenValue) - M(d.GivenItemsDiscountAmount)).toFixed(0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: [E.totalRow, E.netAmount], children: [
          /* @__PURE__ */ r.jsx(a, { children: "Difference:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.ExchangeDifference).toFixed(0) })
        ] }),
        /* @__PURE__ */ r.jsx(m, { style: E.divider }),
        M(d.CashReceived) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Cash received:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.CashReceived).toFixed(0) })
        ] }),
        M(d.BankReceived) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Bank received:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.BankReceived).toFixed(0) })
        ] }),
        M(d.CashReturned) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Cash returned:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.CashReturned).toFixed(0) })
        ] }),
        M(d.BankReturned) > 0 && /* @__PURE__ */ r.jsxs(m, { style: E.totalRow, children: [
          /* @__PURE__ */ r.jsx(a, { children: "Bank returned:" }),
          /* @__PURE__ */ r.jsx(a, { children: M(d.BankReturned).toFixed(0) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: E.footer, wrap: !1, children: [
      /* @__PURE__ */ r.jsxs(a, { style: E.validText, children: [
        "* Valid for ",
        v,
        " days only"
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: E.termsList, children: h.map((_, S) => /* @__PURE__ */ r.jsxs(a, { style: E.termsItem, children: [
        S + 1,
        ". ",
        _
      ] }, S)) }),
      /* @__PURE__ */ r.jsx(a, { style: { marginBottom: 8, color: "#000000", fontWeight: "bold", textShadow: "0.5px 0.5px 0px #000000", letterSpacing: "0.2px", textStroke: "0.2px #000000", WebkitTextStroke: "0.2px #000000" }, children: "* Terms and conditions apply." }),
      /* @__PURE__ */ r.jsxs(m, { style: E.developerInfo, children: [
        /* @__PURE__ */ r.jsxs(a, { children: [
          "Developed by ",
          y.name
        ] }),
        /* @__PURE__ */ r.jsx(a, { children: y.website })
      ] })
    ] })
  ] }) });
}, w = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 15,
    fontFamily: "Helvetica",
    fontSize: 9,
    color: "#333333",
    lineHeight: 1.3
  },
  container: {
    width: "100%",
    padding: 0
  },
  // Header Section - Compact Design
  header: {
    marginBottom: 15,
    borderBottom: "2px solid #2563eb",
    paddingBottom: 10
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 8
  },
  logoSection: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1
  },
  logoImage: {
    width: 40,
    height: 28,
    marginRight: 8
  },
  companyInfo: {
    flex: 1
  },
  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 2,
    lineHeight: 1.2
  },
  companyAddress: {
    fontSize: 9,
    color: "#6b7280",
    marginBottom: 1,
    lineHeight: 1.1
  },
  companyPhone: {
    fontSize: 9,
    color: "#6b7280",
    lineHeight: 1.1
  },
  reportInfo: {
    textAlign: "right",
    flex: 1,
    paddingLeft: 10
  },
  reportTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 3,
    lineHeight: 1.2
  },
  reportSubtitle: {
    fontSize: 10,
    color: "#6b7280",
    marginBottom: 2,
    lineHeight: 1.1
  },
  reportDate: {
    fontSize: 9,
    color: "#9ca3af",
    lineHeight: 1.1
  },
  // Summary Section - Compact Design
  summarySection: {
    backgroundColor: "#f8fafc",
    padding: 12,
    marginBottom: 15,
    borderRadius: 6,
    border: "1px solid #e5e7eb"
  },
  summaryTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 8
  },
  summaryGrid: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  summaryItem: {
    flex: 1,
    textAlign: "center",
    padding: 8,
    backgroundColor: "#ffffff",
    marginHorizontal: 3,
    borderRadius: 4,
    border: "1px solid #e5e7eb"
  },
  summaryLabel: {
    fontSize: 8,
    color: "#6b7280",
    marginBottom: 3,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    lineHeight: 1.1
  },
  summaryValue: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
    lineHeight: 1.2
  },
  // Sales Table Section - Compact Design
  salesSection: {
    marginBottom: 15
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#1e40af",
    marginBottom: 8,
    borderBottom: "1px solid #e5e7eb",
    paddingBottom: 4
  },
  table: {
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: 6,
    overflow: "hidden"
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#1e40af",
    color: "#ffffff",
    paddingVertical: 6,
    paddingHorizontal: 8
  },
  tableHeaderCell: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase",
    letterSpacing: 0.3
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #e5e7eb",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#ffffff"
  },
  tableRowAlt: {
    flexDirection: "row",
    borderBottom: "1px solid #e5e7eb",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#f8fafc"
  },
  tableCell: {
    fontSize: 8,
    color: "#374151",
    lineHeight: 1.2
  },
  // Column widths
  colId: { width: "8%" },
  colSaleNo: { width: "20%" },
  colDate: { width: "15%" },
  colCash: { width: "15%" },
  colBank: { width: "15%" },
  colTotal: { width: "15%" },
  colCashReturn: { width: "12%" },
  // Footer Section - Compact Design
  footer: {
    marginTop: 20,
    paddingTop: 10,
    borderTop: "1px solid #e5e7eb",
    textAlign: "center"
  },
  footerText: {
    fontSize: 7,
    color: "#9ca3af",
    marginBottom: 2,
    lineHeight: 1.1
  },
  developerInfo: {
    fontSize: 7,
    color: "#6b7280",
    marginTop: 3,
    lineHeight: 1.1
  },
  // Utility classes
  textRight: { textAlign: "right" },
  textCenter: { textAlign: "center" },
  textBold: { fontWeight: "bold" },
  textMuted: { color: "#6b7280" },
  textSuccess: { color: "#059669" },
  textWarning: { color: "#d97706" },
  textDanger: { color: "#dc2626" }
}), we = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return "Invalid Date";
  }
}, kr = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return "Invalid Date";
  }
}, re = (d) => d == null ? "0.00" : new Intl.NumberFormat("en-PK", {
  style: "currency",
  currency: "PKR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(d), Cr = (d) => d == null ? "0" : new Intl.NumberFormat("en-US").format(d), Vn = {
  dateRange: {
    start: "2025-10-07",
    end: "2025-10-10",
    startUtc: "2025-10-06T19:00:00Z",
    endUtc: "2025-10-10T18:59:59Z"
  },
  sales: {
    rows: [
      {
        ID: 68,
        SaleNo: "251010163850",
        SaleDate: "2025-10-10T11:38:50",
        CustomerName: null,
        CustomerPhone: null,
        Remarks: null,
        additionalDiscount: 0,
        itemsCount: 2,
        totalDiscount: 0,
        totalAmount: 5e3,
        BankReceived: 5e3,
        CashReceived: 0
      }
    ],
    totals: {
      sales_count: 67,
      cash_received: 32751.97,
      bank_received: 374866.22,
      cash_returned: 0,
      net_revenue: 407618.19
    }
  },
  businessInfo: "Fables By Accoutre",
  exportDate: "2025-10-10T12:45:23.567Z"
}, Qn = ({
  salesData: d = Vn,
  businessName: f,
  businessAddress: v,
  businessPhone: h,
  logoSrc: y,
  showLogo: p = !0
}) => {
  const { dateRange: x, sales: s, businessInfo: l, exportDate: e } = d, t = f || l, o = v || "332-Z, Phase 3, DHA, Lahore", n = h || "+92-335-5765923", i = y || ye;
  return /* @__PURE__ */ r.jsx(ce, { children: /* @__PURE__ */ r.jsx(ue, { size: "A4", style: w.page, children: /* @__PURE__ */ r.jsxs(m, { style: w.container, children: [
    /* @__PURE__ */ r.jsx(m, { style: w.header, children: /* @__PURE__ */ r.jsxs(m, { style: w.headerTop, children: [
      /* @__PURE__ */ r.jsxs(m, { style: w.logoSection, children: [
        p && i && /* @__PURE__ */ r.jsx(ne, { src: i, style: w.logoImage }),
        /* @__PURE__ */ r.jsxs(m, { style: w.companyInfo, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.companyName, children: t }),
          /* @__PURE__ */ r.jsx(a, { style: w.companyAddress, children: o }),
          /* @__PURE__ */ r.jsx(a, { style: w.companyPhone, children: n })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs(m, { style: w.reportInfo, children: [
        /* @__PURE__ */ r.jsx(a, { style: w.reportTitle, children: "Sales Export Report" }),
        /* @__PURE__ */ r.jsxs(a, { style: w.reportSubtitle, children: [
          "Period: ",
          we(x.start),
          " - ",
          we(x.end)
        ] }),
        /* @__PURE__ */ r.jsxs(a, { style: w.reportDate, children: [
          "Generated: ",
          kr(e)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ r.jsxs(m, { style: w.summarySection, children: [
      /* @__PURE__ */ r.jsx(a, { style: w.summaryTitle, children: "Sales Summary" }),
      /* @__PURE__ */ r.jsxs(m, { style: w.summaryGrid, children: [
        /* @__PURE__ */ r.jsxs(m, { style: w.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.summaryLabel, children: "Total Sales" }),
          /* @__PURE__ */ r.jsx(a, { style: w.summaryValue, children: Cr(s.totals.sales_count) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: w.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.summaryLabel, children: "Cash Received" }),
          /* @__PURE__ */ r.jsx(a, { style: w.summaryValue, children: re(s.totals.cash_received || 0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: w.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.summaryLabel, children: "Bank Received" }),
          /* @__PURE__ */ r.jsx(a, { style: w.summaryValue, children: re(s.totals.bank_received || 0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: w.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.summaryLabel, children: "Cash Returned" }),
          /* @__PURE__ */ r.jsx(a, { style: w.summaryValue, children: re(s.totals.cash_returned || 0) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: w.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: w.summaryLabel, children: "Net Revenue" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.summaryValue, w.textSuccess], children: re(s.totals.net_revenue || 0) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: w.salesSection, children: [
      /* @__PURE__ */ r.jsx(a, { style: w.sectionTitle, children: "Sales Details" }),
      /* @__PURE__ */ r.jsxs(m, { style: w.table, children: [
        /* @__PURE__ */ r.jsxs(m, { style: w.tableHeader, children: [
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colId], children: "ID" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colSaleNo], children: "Sale No" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colDate], children: "Date" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colCash, w.textRight], children: "Cash" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colBank, w.textRight], children: "Bank" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colTotal, w.textRight], children: "Total" }),
          /* @__PURE__ */ r.jsx(a, { style: [w.tableHeaderCell, w.colCashReturn, w.textRight], children: "Cash Return" })
        ] }),
        s.rows.map((c, u) => {
          const _ = (c.CashReceived || 0) + (c.BankReceived || 0);
          return /* @__PURE__ */ r.jsxs(m, { style: u % 2 === 0 ? w.tableRow : w.tableRowAlt, children: [
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colId], children: c.ID }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colSaleNo], children: c.SaleNo }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colDate], children: we(c.SaleDate) }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colCash, w.textRight], children: re(c.CashReceived || 0) }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colBank, w.textRight], children: re(c.BankReceived || 0) }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colTotal, w.textRight, w.textBold], children: re(_) }),
            /* @__PURE__ */ r.jsx(a, { style: [w.tableCell, w.colCashReturn, w.textRight], children: re(c.CashReturned || 0) })
          ] }, c.ID);
        })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: w.footer, children: [
      /* @__PURE__ */ r.jsxs(a, { style: w.footerText, children: [
        "This report was generated on ",
        kr(e)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: w.footerText, children: [
        "Report covers ",
        we(x.start),
        " to ",
        we(x.end)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: w.footerText, children: [
        "Total of ",
        Cr(s.rows.length),
        " sales transactions"
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: w.developerInfo, children: /* @__PURE__ */ r.jsx(a, { children: "Developed by Esper Solutions | www.esper.solutions" }) })
    ] })
  ] }) }) });
}, b = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 15,
    fontFamily: "Helvetica",
    fontSize: 9,
    color: "#333333",
    lineHeight: 1.3
  },
  container: {
    width: "100%",
    padding: 0
  },
  // Header Section - Compact Design
  header: {
    marginBottom: 15,
    borderBottom: "2px solid #dc2626",
    // Red color for returns
    paddingBottom: 10
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 8
  },
  logoSection: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1
  },
  logoImage: {
    width: 40,
    height: 28,
    marginRight: 8
  },
  companyInfo: {
    flex: 1
  },
  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#dc2626",
    // Red color for returns
    marginBottom: 2,
    lineHeight: 1.2
  },
  companyAddress: {
    fontSize: 9,
    color: "#6b7280",
    marginBottom: 1,
    lineHeight: 1.1
  },
  companyPhone: {
    fontSize: 9,
    color: "#6b7280",
    lineHeight: 1.1
  },
  reportInfo: {
    textAlign: "right",
    flex: 1,
    paddingLeft: 10
  },
  reportTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#dc2626",
    // Red color for returns
    marginBottom: 3,
    lineHeight: 1.2
  },
  reportSubtitle: {
    fontSize: 10,
    color: "#6b7280",
    marginBottom: 2,
    lineHeight: 1.1
  },
  reportDate: {
    fontSize: 9,
    color: "#9ca3af",
    lineHeight: 1.1
  },
  // Summary Section - Compact Design
  summarySection: {
    backgroundColor: "#fef2f2",
    // Light red background for returns
    padding: 12,
    marginBottom: 15,
    borderRadius: 6,
    border: "1px solid #fecaca"
  },
  summaryTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#dc2626",
    marginBottom: 8
  },
  summaryGrid: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  summaryItem: {
    flex: 1,
    textAlign: "center",
    padding: 8,
    backgroundColor: "#ffffff",
    marginHorizontal: 3,
    borderRadius: 4,
    border: "1px solid #fecaca"
  },
  summaryLabel: {
    fontSize: 8,
    color: "#6b7280",
    marginBottom: 3,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    lineHeight: 1.1
  },
  summaryValue: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#dc2626",
    lineHeight: 1.2
  },
  // Returns Table Section - Compact Design
  returnsSection: {
    marginBottom: 15
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#dc2626",
    marginBottom: 8,
    borderBottom: "1px solid #fecaca",
    paddingBottom: 4
  },
  table: {
    width: "100%",
    border: "1px solid #fecaca",
    borderRadius: 6,
    overflow: "hidden"
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#dc2626",
    color: "#ffffff",
    paddingVertical: 6,
    paddingHorizontal: 8
  },
  tableHeaderCell: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase",
    letterSpacing: 0.3
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #fecaca",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#ffffff"
  },
  tableRowAlt: {
    flexDirection: "row",
    borderBottom: "1px solid #fecaca",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#fef2f2"
  },
  tableCell: {
    fontSize: 8,
    color: "#374151",
    lineHeight: 1.2
  },
  // Column widths for returns - updated for new data structure
  colSaleNo: { width: "12%" },
  colReturnId: { width: "10%" },
  colReturnDate: { width: "12%" },
  colQuantity: { width: "7%" },
  colPrice: { width: "9%" },
  colDiscount: { width: "9%" },
  colAdditionalReturnDiscount: { width: "12%" },
  colNetPrice: { width: "9%" },
  colTotalAmount: { width: "10%" },
  // Footer Section - Compact Design
  footer: {
    marginTop: 20,
    paddingTop: 10,
    borderTop: "1px solid #fecaca",
    textAlign: "center"
  },
  footerText: {
    fontSize: 7,
    color: "#9ca3af",
    marginBottom: 2,
    lineHeight: 1.1
  },
  developerInfo: {
    fontSize: 7,
    color: "#6b7280",
    marginTop: 3,
    lineHeight: 1.1
  },
  // Utility classes
  textRight: { textAlign: "right" },
  textCenter: { textAlign: "center" },
  textBold: { fontWeight: "bold" },
  textMuted: { color: "#6b7280" },
  textSuccess: { color: "#059669" },
  textWarning: { color: "#d97706" },
  textDanger: { color: "#dc2626" }
}), Re = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return "Invalid Date";
  }
}, Pr = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return "Invalid Date";
  }
}, Z = (d) => d == null ? "0.00" : new Intl.NumberFormat("en-PK", {
  style: "currency",
  currency: "PKR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(d), gt = (d) => d == null ? "0" : new Intl.NumberFormat("en-US").format(d), Un = {
  dateRange: {
    start: "2025-10-05",
    end: "2025-10-11",
    startUtc: "2025-10-04T19:00:00+00:00",
    endUtc: "2025-10-11T18:59:59+00:00"
  },
  returns: {
    rows: [
      {
        sale_no: "251010163850",
        return_id: "ret-{return_item.return_id}",
        return_created_date: "2025-10-10T11:47:22",
        quantity: 1,
        additional_return_discount: 0,
        price: 3400,
        discount: 0,
        net_price: 3400,
        total_amount: 3400
      },
      {
        sale_no: "251010163850",
        return_id: "ret-{return_item.return_id}",
        return_created_date: "2025-10-10T11:39:12",
        quantity: 1,
        additional_return_discount: 0,
        price: 1600,
        discount: 0,
        net_price: 1600,
        total_amount: 1600
      }
    ],
    totals: {
      returns_count: 38,
      total_amount: 68750
    }
  },
  businessInfo: "Fables By Accoutre",
  exportDate: "2025-10-10T22:25:40.896757+00:00"
}, $n = ({
  returnsData: d = Un,
  businessName: f,
  businessAddress: v,
  businessPhone: h,
  logoSrc: y,
  showLogo: p = !0
}) => {
  const { dateRange: x, returns: s, businessInfo: l, exportDate: e } = d, t = f || l, o = v || "332-Z, Phase 3, DHA, Lahore", n = h || "+92-335-5765923", i = y || ye;
  return /* @__PURE__ */ r.jsx(ce, { children: /* @__PURE__ */ r.jsx(ue, { size: "A4", style: b.page, children: /* @__PURE__ */ r.jsxs(m, { style: b.container, children: [
    /* @__PURE__ */ r.jsx(m, { style: b.header, children: /* @__PURE__ */ r.jsxs(m, { style: b.headerTop, children: [
      /* @__PURE__ */ r.jsxs(m, { style: b.logoSection, children: [
        p && i && /* @__PURE__ */ r.jsx(ne, { src: i, style: b.logoImage }),
        /* @__PURE__ */ r.jsxs(m, { style: b.companyInfo, children: [
          /* @__PURE__ */ r.jsx(a, { style: b.companyName, children: t }),
          /* @__PURE__ */ r.jsx(a, { style: b.companyAddress, children: o }),
          /* @__PURE__ */ r.jsx(a, { style: b.companyPhone, children: n })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs(m, { style: b.reportInfo, children: [
        /* @__PURE__ */ r.jsx(a, { style: b.reportTitle, children: "Sale Returns Report" }),
        /* @__PURE__ */ r.jsxs(a, { style: b.reportSubtitle, children: [
          "Period: ",
          Re(x.start),
          " - ",
          Re(x.end)
        ] }),
        /* @__PURE__ */ r.jsxs(a, { style: b.reportDate, children: [
          "Generated: ",
          Pr(e)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ r.jsxs(m, { style: b.summarySection, children: [
      /* @__PURE__ */ r.jsx(a, { style: b.summaryTitle, children: "Returns Summary" }),
      /* @__PURE__ */ r.jsxs(m, { style: b.summaryGrid, children: [
        /* @__PURE__ */ r.jsxs(m, { style: b.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: b.summaryLabel, children: "Total Items" }),
          /* @__PURE__ */ r.jsx(a, { style: b.summaryValue, children: gt(s.totals.returns_count) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: b.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: b.summaryLabel, children: "Total Amount" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.summaryValue, b.textDanger], children: Z(s.totals.total_amount) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: b.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: b.summaryLabel, children: "Total Additional Discount" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.summaryValue, b.textDanger], children: Z(s.rows.reduce((c, u) => c + (u.additional_return_discount || 0), 0)) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: b.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: b.summaryLabel, children: "Average Return" }),
          /* @__PURE__ */ r.jsx(a, { style: b.summaryValue, children: Z(s.totals.returns_count > 0 ? s.totals.total_amount / s.totals.returns_count : 0) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: b.returnsSection, children: [
      /* @__PURE__ */ r.jsx(a, { style: b.sectionTitle, children: "Returns Details" }),
      /* @__PURE__ */ r.jsxs(m, { style: b.table, children: [
        /* @__PURE__ */ r.jsxs(m, { style: b.tableHeader, children: [
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colSaleNo], children: "Sale No" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colReturnId], children: "Return ID" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colReturnDate], children: "Return Date" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colQuantity, b.textCenter], children: "Qty" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colPrice, b.textRight], children: "Price" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colDiscount, b.textRight], children: "Discount" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colAdditionalReturnDiscount, b.textRight], children: "Add. Return Disc." }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colNetPrice, b.textRight], children: "Net Price" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableHeaderCell, b.colTotalAmount, b.textRight], children: "Total" })
        ] }),
        s.rows.map((c, u) => /* @__PURE__ */ r.jsxs(m, { style: u % 2 === 0 ? b.tableRow : b.tableRowAlt, children: [
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colSaleNo], children: c.sale_no }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colReturnId, b.textMuted], children: c.return_id }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colReturnDate], children: Re(c.return_created_date) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colQuantity, b.textCenter], children: gt(c.quantity) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colPrice, b.textRight], children: Z(c.price) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colDiscount, b.textRight], children: Z(c.discount || 0) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colAdditionalReturnDiscount, b.textRight, b.textDanger], children: Z(c.additional_return_discount || 0) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colNetPrice, b.textRight], children: Z(c.net_price) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colTotalAmount, b.textRight, b.textBold], children: Z(c.total_amount) })
        ] }, `${c.sale_no}-${u}`)),
        /* @__PURE__ */ r.jsxs(m, { style: [b.tableRow, { backgroundColor: "#f3f4f6", borderTop: "2px solid #dc2626" }], children: [
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colSaleNo, b.textBold], children: "TOTALS" }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colReturnId] }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colReturnDate] }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colQuantity, b.textCenter, b.textBold], children: gt(s.rows.reduce((c, u) => c + u.quantity, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colPrice, b.textRight, b.textBold], children: Z(s.rows.reduce((c, u) => c + u.price, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colDiscount, b.textRight, b.textBold], children: Z(s.rows.reduce((c, u) => c + (u.discount || 0), 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colAdditionalReturnDiscount, b.textRight, b.textBold, b.textDanger], children: Z(s.rows.reduce((c, u) => c + (u.additional_return_discount || 0), 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colNetPrice, b.textRight, b.textBold], children: Z(s.rows.reduce((c, u) => c + u.net_price, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [b.tableCell, b.colTotalAmount, b.textRight, b.textBold, b.textDanger], children: Z(s.totals.total_amount) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: b.footer, children: [
      /* @__PURE__ */ r.jsxs(a, { style: b.footerText, children: [
        "This returns report was generated on ",
        Pr(e)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: b.footerText, children: [
        "Report covers ",
        Re(x.start),
        " to ",
        Re(x.end)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: b.footerText, children: [
        "Total of ",
        gt(s.rows.length),
        " return items"
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: b.developerInfo, children: /* @__PURE__ */ r.jsx(a, { children: "Developed by Esper Solutions | www.esper.solutions" }) })
    ] })
  ] }) }) });
}, g = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 15,
    fontFamily: "Helvetica",
    fontSize: 9,
    color: "#333333",
    lineHeight: 1.3
  },
  container: {
    width: "100%",
    padding: 0
  },
  // Header Section - Compact Design
  header: {
    marginBottom: 15,
    borderBottom: "2px solid #7c3aed",
    // Purple color for exchanges
    paddingBottom: 10
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 8
  },
  logoSection: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1
  },
  logoImage: {
    width: 40,
    height: 28,
    marginRight: 8
  },
  companyInfo: {
    flex: 1
  },
  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#7c3aed",
    // Purple color for exchanges
    marginBottom: 2,
    lineHeight: 1.2
  },
  companyAddress: {
    fontSize: 9,
    color: "#6b7280",
    marginBottom: 1,
    lineHeight: 1.1
  },
  companyPhone: {
    fontSize: 9,
    color: "#6b7280",
    lineHeight: 1.1
  },
  reportInfo: {
    textAlign: "right",
    flex: 1,
    paddingLeft: 10
  },
  reportTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#7c3aed",
    // Purple color for exchanges
    marginBottom: 3,
    lineHeight: 1.2
  },
  reportSubtitle: {
    fontSize: 10,
    color: "#6b7280",
    marginBottom: 2,
    lineHeight: 1.1
  },
  reportDate: {
    fontSize: 9,
    color: "#9ca3af",
    lineHeight: 1.1
  },
  // Summary Section - Compact Design
  summarySection: {
    backgroundColor: "#faf5ff",
    // Light purple background for exchanges
    padding: 12,
    marginBottom: 15,
    borderRadius: 6,
    border: "1px solid #d8b4fe"
  },
  summaryTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#7c3aed",
    marginBottom: 8
  },
  summaryGrid: {
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  summaryItem: {
    flex: 1,
    textAlign: "center",
    padding: 8,
    backgroundColor: "#ffffff",
    marginHorizontal: 3,
    marginVertical: 3,
    borderRadius: 4,
    border: "1px solid #d8b4fe",
    minWidth: "22%"
  },
  summaryLabel: {
    fontSize: 8,
    color: "#6b7280",
    marginBottom: 3,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    lineHeight: 1.1
  },
  summaryValue: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#7c3aed",
    lineHeight: 1.2
  },
  // Exchanges Table Section - Compact Design
  exchangesSection: {
    marginBottom: 15
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#7c3aed",
    marginBottom: 8,
    borderBottom: "1px solid #d8b4fe",
    paddingBottom: 4
  },
  table: {
    width: "100%",
    border: "1px solid #d8b4fe",
    borderRadius: 6,
    overflow: "hidden"
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#7c3aed",
    color: "#ffffff",
    paddingVertical: 6,
    paddingHorizontal: 8
  },
  tableHeaderCell: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase",
    letterSpacing: 0.3
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #d8b4fe",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#ffffff"
  },
  tableRowAlt: {
    flexDirection: "row",
    borderBottom: "1px solid #d8b4fe",
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: "#faf5ff"
  },
  tableCell: {
    fontSize: 8,
    color: "#374151",
    lineHeight: 1.2
  },
  // Column widths for exchanges
  colExchangeNo: { width: "18%" },
  colExchangeDate: { width: "12%" },
  colQuantity: { width: "7%" },
  colReturnValue: { width: "10%" },
  colGivenValue: { width: "10%" },
  colCashReceived: { width: "9%" },
  colCashReturned: { width: "9%" },
  colBankReceived: { width: "8%" },
  colBankReturned: { width: "8%" },
  colNetPrice: { width: "9%" },
  // Footer Section - Compact Design
  footer: {
    marginTop: 20,
    paddingTop: 10,
    borderTop: "1px solid #d8b4fe",
    textAlign: "center"
  },
  footerText: {
    fontSize: 7,
    color: "#9ca3af",
    marginBottom: 2,
    lineHeight: 1.1
  },
  developerInfo: {
    fontSize: 7,
    color: "#6b7280",
    marginTop: 3,
    lineHeight: 1.1
  },
  // Utility classes
  textRight: { textAlign: "right" },
  textCenter: { textAlign: "center" },
  textBold: { fontWeight: "bold" },
  textMuted: { color: "#6b7280" },
  textSuccess: { color: "#059669" },
  textWarning: { color: "#d97706" },
  textDanger: { color: "#dc2626" },
  textInfo: { color: "#7c3aed" }
}), Ee = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  } catch {
    return "Invalid Date";
  }
}, Ir = (d) => {
  if (!d) return "N/A";
  try {
    return new Date(d).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return "Invalid Date";
  }
}, z = (d) => d == null ? "0.00" : new Intl.NumberFormat("en-PK", {
  style: "currency",
  currency: "PKR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(d), mt = (d) => d == null ? "0" : new Intl.NumberFormat("en-US").format(d), Gn = {
  dateRange: {
    start: "2025-10-11",
    end: "2025-10-12",
    startUtc: "2025-10-10T19:00:00+00:00",
    endUtc: "2025-10-12T18:59:59+00:00"
  },
  exchanges: {
    rows: [
      {
        exchange_id: 6,
        exchange_no: "EX-20251011-193214",
        exchange_date: "2025-10-11T14:32:00",
        total_return_value: 6e3,
        total_given_value: 6800,
        cash_received: 60,
        cash_returned: 59.4,
        bank_received: 0,
        bank_returned: 0,
        quantity: 2,
        net_price: 6400,
        total_amount: 6400
      }
    ],
    totals: {
      exchanges_count: 1,
      total_return_value: 3e3,
      total_given_value: 3400,
      total_exchange_difference: 0.3,
      total_cash_received: 30,
      total_cash_returned: 29.7,
      total_bank_received: 0,
      total_bank_returned: 0
    }
  },
  businessInfo: "Fables By Accoutre",
  exportDate: "2025-10-12T16:43:05.742466+00:00"
}, eo = ({
  exchangesData: d = Gn,
  businessName: f,
  businessAddress: v,
  businessPhone: h,
  logoSrc: y,
  showLogo: p = !0
}) => {
  const { dateRange: x, exchanges: s, businessInfo: l, exportDate: e } = d, t = f || l, o = v || "332-Z, Phase 3, DHA, Lahore", n = h || "+92-335-5765923", i = y || ye;
  return /* @__PURE__ */ r.jsx(ce, { children: /* @__PURE__ */ r.jsx(ue, { size: "A4", style: g.page, children: /* @__PURE__ */ r.jsxs(m, { style: g.container, children: [
    /* @__PURE__ */ r.jsx(m, { style: g.header, children: /* @__PURE__ */ r.jsxs(m, { style: g.headerTop, children: [
      /* @__PURE__ */ r.jsxs(m, { style: g.logoSection, children: [
        p && i && /* @__PURE__ */ r.jsx(ne, { src: i, style: g.logoImage }),
        /* @__PURE__ */ r.jsxs(m, { style: g.companyInfo, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.companyName, children: t }),
          /* @__PURE__ */ r.jsx(a, { style: g.companyAddress, children: o }),
          /* @__PURE__ */ r.jsx(a, { style: g.companyPhone, children: n })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs(m, { style: g.reportInfo, children: [
        /* @__PURE__ */ r.jsx(a, { style: g.reportTitle, children: "Items Exchange Report" }),
        /* @__PURE__ */ r.jsxs(a, { style: g.reportSubtitle, children: [
          "Period: ",
          Ee(x.start),
          " - ",
          Ee(x.end)
        ] }),
        /* @__PURE__ */ r.jsxs(a, { style: g.reportDate, children: [
          "Generated: ",
          Ir(e)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ r.jsxs(m, { style: g.summarySection, children: [
      /* @__PURE__ */ r.jsx(a, { style: g.summaryTitle, children: "Exchange Summary" }),
      /* @__PURE__ */ r.jsxs(m, { style: g.summaryGrid, children: [
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Total Exchanges" }),
          /* @__PURE__ */ r.jsx(a, { style: g.summaryValue, children: mt(s.totals.exchanges_count) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Total Return Value" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textDanger], children: z(s.totals.total_return_value) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Total Given Value" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textSuccess], children: z(s.totals.total_given_value) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Exchange Difference" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textInfo], children: z(s.totals.total_exchange_difference) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Cash Received" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textSuccess], children: z(s.totals.total_cash_received) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Cash Returned" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textDanger], children: z(s.totals.total_cash_returned) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Bank Received" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textSuccess], children: z(s.totals.total_bank_received) })
        ] }),
        /* @__PURE__ */ r.jsxs(m, { style: g.summaryItem, children: [
          /* @__PURE__ */ r.jsx(a, { style: g.summaryLabel, children: "Bank Returned" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.summaryValue, g.textDanger], children: z(s.totals.total_bank_returned) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: g.exchangesSection, children: [
      /* @__PURE__ */ r.jsx(a, { style: g.sectionTitle, children: "Exchange Details" }),
      /* @__PURE__ */ r.jsxs(m, { style: g.table, children: [
        /* @__PURE__ */ r.jsxs(m, { style: g.tableHeader, children: [
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colExchangeNo], children: "Exchange No" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colExchangeDate], children: "Date" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colQuantity, g.textCenter], children: "Qty" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colReturnValue, g.textRight], children: "Return Value" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colGivenValue, g.textRight], children: "Given Value" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colCashReceived, g.textRight], children: "Cash Rec." }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colCashReturned, g.textRight], children: "Cash Ret." }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colBankReceived, g.textRight], children: "Bank Rec." }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colBankReturned, g.textRight], children: "Bank Ret." }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableHeaderCell, g.colNetPrice, g.textRight], children: "Net Price" })
        ] }),
        s.rows.map((c, u) => /* @__PURE__ */ r.jsxs(m, { style: u % 2 === 0 ? g.tableRow : g.tableRowAlt, children: [
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colExchangeNo], children: c.exchange_no }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colExchangeDate], children: Ee(c.exchange_date) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colQuantity, g.textCenter], children: mt(c.quantity) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colReturnValue, g.textRight, g.textDanger], children: z(c.total_return_value) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colGivenValue, g.textRight, g.textSuccess], children: z(c.total_given_value) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colCashReceived, g.textRight, g.textSuccess], children: z(c.cash_received) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colCashReturned, g.textRight, g.textDanger], children: z(c.cash_returned) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colBankReceived, g.textRight, g.textSuccess], children: z(c.bank_received) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colBankReturned, g.textRight, g.textDanger], children: z(c.bank_returned) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colNetPrice, g.textRight, g.textBold], children: z(c.net_price) })
        ] }, `${c.exchange_id}-${u}`)),
        /* @__PURE__ */ r.jsxs(m, { style: [g.tableRow, { backgroundColor: "#f3f4f6", borderTop: "2px solid #7c3aed" }], children: [
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colExchangeNo, g.textBold], children: "TOTALS" }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colExchangeDate] }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colQuantity, g.textCenter, g.textBold], children: mt(s.rows.reduce((c, u) => c + u.quantity, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colReturnValue, g.textRight, g.textBold, g.textDanger], children: z(s.rows.reduce((c, u) => c + u.total_return_value, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colGivenValue, g.textRight, g.textBold, g.textSuccess], children: z(s.rows.reduce((c, u) => c + u.total_given_value, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colCashReceived, g.textRight, g.textBold, g.textSuccess], children: z(s.rows.reduce((c, u) => c + u.cash_received, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colCashReturned, g.textRight, g.textBold, g.textDanger], children: z(s.rows.reduce((c, u) => c + u.cash_returned, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colBankReceived, g.textRight, g.textBold, g.textSuccess], children: z(s.rows.reduce((c, u) => c + u.bank_received, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colBankReturned, g.textRight, g.textBold, g.textDanger], children: z(s.rows.reduce((c, u) => c + u.bank_returned, 0)) }),
          /* @__PURE__ */ r.jsx(a, { style: [g.tableCell, g.colNetPrice, g.textRight, g.textBold, g.textInfo], children: z(s.rows.reduce((c, u) => c + u.net_price, 0)) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: g.footer, children: [
      /* @__PURE__ */ r.jsxs(a, { style: g.footerText, children: [
        "This exchange report was generated on ",
        Ir(e)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: g.footerText, children: [
        "Report covers ",
        Ee(x.start),
        " to ",
        Ee(x.end)
      ] }),
      /* @__PURE__ */ r.jsxs(a, { style: g.footerText, children: [
        "Total of ",
        mt(s.rows.length),
        " exchange transactions"
      ] }),
      /* @__PURE__ */ r.jsx(m, { style: g.developerInfo, children: /* @__PURE__ */ r.jsx(a, { children: "Developed by Esper Solutions | www.esper.solutions" }) })
    ] })
  ] }) }) });
}, O = le.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 24,
    fontFamily: "Helvetica",
    fontSize: 9,
    color: "#333333",
    lineHeight: 1.3
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    borderBottom: "2px solid #b45309",
    paddingBottom: 10,
    marginBottom: 12
  },
  brand: { flexDirection: "row", alignItems: "center", flex: 1 },
  logo: { width: 40, height: 28, marginRight: 8 },
  businessName: { fontSize: 14, fontWeight: "bold", color: "#b45309", marginBottom: 2 },
  muted: { fontSize: 9, color: "#6b7280" },
  titleBlock: { flex: 1, textAlign: "right" },
  title: { fontSize: 14, fontWeight: "bold", color: "#b45309", marginBottom: 3 },
  dispatchNo: { fontSize: 11, fontWeight: "bold", marginBottom: 2 },
  metaRow: { flexDirection: "row", marginBottom: 12, gap: 8 },
  metaBox: { flex: 1, border: "1px solid #e5e7eb", borderRadius: 3, padding: 6 },
  metaLabel: { fontSize: 8, color: "#6b7280", marginBottom: 2 },
  metaValue: { fontSize: 10, fontWeight: "bold" },
  table: { border: "1px solid #e5e7eb", borderRadius: 3 },
  row: { flexDirection: "row", borderBottom: "1px solid #f3f4f6", paddingVertical: 4, paddingHorizontal: 4 },
  headRow: { flexDirection: "row", backgroundColor: "#fef3c7", paddingVertical: 5, paddingHorizontal: 4 },
  totalRow: { flexDirection: "row", backgroundColor: "#f9fafb", paddingVertical: 5, paddingHorizontal: 4 },
  th: { fontSize: 8, fontWeight: "bold", color: "#92400e" },
  bold: { fontWeight: "bold" },
  colNo: { width: "4%" },
  colItem: { width: "30%", paddingRight: 8 },
  colBarcode: { width: "10%", paddingRight: 4 },
  colQty: { width: "5%", textAlign: "right", paddingRight: 6 },
  colReason: { width: "19%", paddingRight: 4 },
  colRecorded: { width: "14%", paddingRight: 4 },
  colValue: { width: "11%", textAlign: "right", paddingRight: 6 },
  received: { width: "7%", textAlign: "center", fontSize: 8, color: "#6b7280" },
  remarks: { marginTop: 10, padding: 6, border: "1px solid #e5e7eb", borderRadius: 3 },
  signatures: { flexDirection: "row", justifyContent: "space-between", marginTop: 36, gap: 24 },
  signature: { flex: 1, borderTop: "1px solid #9ca3af", paddingTop: 4, fontSize: 9, color: "#4b5563" },
  footer: { position: "absolute", bottom: 14, left: 24, right: 24, fontSize: 8, color: "#9ca3af", textAlign: "center" }
}), to = ({
  logoSrc: d,
  businessName: f,
  branchName: v,
  businessAddress: h,
  businessPhone: y,
  dispatchNo: p,
  dispatchDate: x,
  periodText: s,
  sentBy: l,
  remarks: e,
  totalQuantity: t,
  totalValue: o,
  lines: n = []
}) => /* @__PURE__ */ r.jsx(ce, { title: `Damages ${p}`, children: /* @__PURE__ */ r.jsxs(ue, { size: "A4", style: O.page, children: [
  /* @__PURE__ */ r.jsxs(m, { style: O.header, children: [
    /* @__PURE__ */ r.jsxs(m, { style: O.brand, children: [
      /* @__PURE__ */ r.jsx(ne, { style: O.logo, src: d || ye }),
      /* @__PURE__ */ r.jsxs(m, { children: [
        /* @__PURE__ */ r.jsx(a, { style: O.businessName, children: [f, v].filter(Boolean).join(" - ") }),
        h ? /* @__PURE__ */ r.jsx(a, { style: O.muted, children: h }) : null,
        y ? /* @__PURE__ */ r.jsx(a, { style: O.muted, children: y }) : null
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: O.titleBlock, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.title, children: "Damages sent to warehouse" }),
      /* @__PURE__ */ r.jsx(a, { style: O.dispatchNo, children: p }),
      /* @__PURE__ */ r.jsx(a, { style: O.muted, children: x })
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs(m, { style: O.metaRow, children: [
    /* @__PURE__ */ r.jsxs(m, { style: O.metaBox, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.metaLabel, children: "Damages recorded" }),
      /* @__PURE__ */ r.jsx(a, { style: O.metaValue, children: s })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: O.metaBox, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.metaLabel, children: "Pieces" }),
      /* @__PURE__ */ r.jsx(a, { style: O.metaValue, children: t })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: O.metaBox, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.metaLabel, children: "Value at POS price" }),
      /* @__PURE__ */ r.jsx(a, { style: O.metaValue, children: o })
    ] }),
    /* @__PURE__ */ r.jsxs(m, { style: O.metaBox, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.metaLabel, children: "Sent by" }),
      /* @__PURE__ */ r.jsx(a, { style: O.metaValue, children: l || "-" })
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs(m, { style: O.table, children: [
    /* @__PURE__ */ r.jsxs(m, { style: O.headRow, fixed: !0, children: [
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colNo], children: "#" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colItem], children: "Item" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colBarcode], children: "Barcode" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colQty], children: "Qty" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colReason], children: "Reason" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colRecorded], children: "Recorded" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.colValue], children: "Value" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.th, O.received], children: "Received" })
    ] }),
    n.map((i, c) => /* @__PURE__ */ r.jsxs(m, { style: O.row, wrap: !1, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.colNo, children: c + 1 }),
      /* @__PURE__ */ r.jsx(a, { style: O.colItem, children: i.name }),
      /* @__PURE__ */ r.jsx(a, { style: O.colBarcode, children: i.barcode || "-" }),
      /* @__PURE__ */ r.jsx(a, { style: [O.colQty, O.bold], children: i.quantity }),
      /* @__PURE__ */ r.jsx(a, { style: O.colReason, children: i.remarks ? `${i.reason} - ${i.remarks}` : i.reason }),
      /* @__PURE__ */ r.jsx(a, { style: O.colRecorded, children: i.recorded }),
      /* @__PURE__ */ r.jsx(a, { style: O.colValue, children: i.value }),
      /* @__PURE__ */ r.jsx(a, { style: O.received, children: "[    ]" })
    ] }, c)),
    /* @__PURE__ */ r.jsxs(m, { style: O.totalRow, wrap: !1, children: [
      /* @__PURE__ */ r.jsx(a, { style: O.colNo }),
      /* @__PURE__ */ r.jsx(a, { style: [O.colItem, O.bold], children: "Total" }),
      /* @__PURE__ */ r.jsx(a, { style: O.colBarcode }),
      /* @__PURE__ */ r.jsx(a, { style: [O.colQty, O.bold], children: t }),
      /* @__PURE__ */ r.jsx(a, { style: O.colReason }),
      /* @__PURE__ */ r.jsx(a, { style: O.colRecorded }),
      /* @__PURE__ */ r.jsx(a, { style: [O.colValue, O.bold], children: o }),
      /* @__PURE__ */ r.jsx(a, { style: O.received })
    ] })
  ] }),
  e ? /* @__PURE__ */ r.jsxs(m, { style: O.remarks, children: [
    /* @__PURE__ */ r.jsx(a, { style: O.metaLabel, children: "Remarks" }),
    /* @__PURE__ */ r.jsx(a, { children: e })
  ] }) : null,
  /* @__PURE__ */ r.jsxs(m, { style: O.signatures, wrap: !1, children: [
    /* @__PURE__ */ r.jsx(a, { style: O.signature, children: "Sent by (store)" }),
    /* @__PURE__ */ r.jsx(a, { style: O.signature, children: "Pieces received at warehouse" }),
    /* @__PURE__ */ r.jsx(a, { style: O.signature, children: "Received by (warehouse)" })
  ] }),
  /* @__PURE__ */ r.jsx(
    a,
    {
      style: O.footer,
      fixed: !0,
      render: ({ pageNumber: i, totalPages: c }) => `${p} - page ${i} of ${c}`
    }
  )
] }) });
export {
  to as DamageDispatchExport,
  Yn as EnhancedPrintQuality,
  eo as ExchangeExports,
  Jn as ExchangeReceipt,
  Kn as Receipt,
  Kn as ReceiptGenerator,
  $n as SaleReturnExports,
  Qn as SalesExports,
  Kn as UltraDarkReceipt,
  Kn as default,
  oo as pdf
};
